var _metadata, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubsetFontinSansCrBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20170731 at Wed Jul 19 15:14:16 2023\n By Aleksey,,,\nCopyright (c) 2009 by Jos Buivenga. All rights reserved.\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "FontinSansCR-Bold",
    horizAdvX: 1044
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Fontin Sans CR",
    fontWeight: 700,
    fontStretch: "normal",
    unitsPerEm: 2048,
    panose1: "2 0 0 0 0 0 0 0 0 0",
    ascent: 1638,
    descent: -410,
    xHeight: 1034,
    capHeight: 1368,
    bbox: "-121 -520 2408 1800",
    underlineThickness: 102,
    underlinePosition: -307,
    unicodeRange: "U+0020-2122"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 1024
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ff",
    unicode: "ff",
    horizAdvX: 1384,
    d: "M633 1565q200 0 342 -86q89 86 231 86q136 0 271 -78l-86 -207q-83 66 -164 66q-48 0 -76.5 -36.5t-28.5 -115.5v-160h258l-67 -190h-191v-611l23 -233h-277v844h-438v-611l23 -233h-277v844h-125v190h125v103q0 85 30.5 158t79.5 121.5t110.5 83t121.5 50t115 15.5z M430 1133v-99h438v123q0 55 11 127q-119 70 -224 70q-98 0 -161.5 -55t-63.5 -166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fi",
    unicode: "fi",
    horizAdvX: 1273,
    d: "M1110 1065v-889l23 -176h-277v772l-8 72h-418v-611l23 -233h-277v844h-125v190h125v103q0 85 30.5 158t79.5 121.5t110.5 83t121.5 50t115 15.5q77 0 147 -13.5t114.5 -32.5t78.5 -38.5t49 -32.5l14 -14l-73 -213q-46 48 -135.5 90.5t-172.5 42.5q-98 0 -161.5 -55 t-63.5 -166v-99h397z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fl",
    unicode: "fl",
    horizAdvX: 1273,
    d: "M430 1034h258l-67 -190h-191v-611l23 -233h-277v844h-125v190h125v103q0 85 30.5 158t79.5 121.5t110.5 83t121.5 50t115 15.5q67 0 225 -42.5t252 -58.5v-1288l23 -176h-277v1296q-110 58 -201 58q-98 0 -161.5 -55t-63.5 -166v-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ffi",
    unicode: "ffi",
    horizAdvX: 1966,
    d: "M1802 1065v-889l23 -176h-277v772l-8 72h-418v-611l23 -233h-277v844h-438v-611l23 -233h-277v844h-125v190h125v103q0 85 30.5 158t79.5 121.5t110.5 83t121.5 50t115 15.5q140 0 236 -36.5t147 -78.5q67 56 151.5 85.5t157.5 29.5q77 0 147 -13.5t115 -32.5t78.5 -38.5 t48.5 -32.5l15 -14l-74 -213q-46 48 -135 90.5t-172 42.5q-98 0 -162 -55t-64 -166v-99h398zM868 1034v103q0 72 23 139q-120 78 -236 78q-98 0 -161.5 -55t-63.5 -166v-99h438z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ffl",
    unicode: "ffl",
    horizAdvX: 1966,
    d: "M1122 1034h258l-67 -190h-191v-611l23 -233h-277v844h-438v-611l23 -233h-277v844h-125v190h125v103q0 85 30.5 158t79.5 121.5t110.5 83t121.5 50t115 15.5q140 0 236 -36.5t147 -78.5q67 56 151.5 85.5t157.5 29.5q67 0 225 -42.5t252 -58.5v-1288l23 -176h-277v1296 q-110 58 -200 58q-98 0 -162 -55t-64 -166v-99zM430 1133v-99h438v103q0 72 23 139q-120 78 -236 78q-98 0 -161.5 -55t-63.5 -166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fj",
    unicode: "fj",
    horizAdvX: 1265,
    d: "M1110 1065v-1030q0 -236 -116.5 -384.5t-295.5 -150.5l-88 211q134 0 190 91t56 255v736l-8 51h-418v-611l23 -233h-277v844h-125v190h125v103q0 85 30.5 158t79.5 121.5t110.5 83t121.5 50t115 15.5q77 0 147 -13.5t114.5 -32.5t78.5 -38.5t49 -32.5l14 -14l-73 -213 q-46 48 -135.5 90.5t-172.5 42.5q-98 0 -161.5 -55t-63.5 -166v-99h397z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 1024
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    horizAdvX: 682
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 512
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 561,
    d: "M438 1569l-57 -1125l-188 -30l-43 923l-29 191zM444 125q0 -64 -43 -108t-110 -44t-110.5 44t-43.5 108q0 61 44.5 107.5t109.5 46.5t109 -46.5t44 -107.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 841,
    d: "M346 874h-199l7 259l-37 204l229 39v-502zM694 874h-198l6 259l-37 204l229 39v-502z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 1462,
    d: "M1323 346h-289l-39 -346h-241l41 346h-248l-39 -346h-242l41 346h-278v193h297l36 319h-276v193h295l33 297h239l-35 -297h248l33 297h242l-35 -297h295l-23 -193h-288l-37 -319h293zM813 539l37 319h-248l-37 -319h248z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 1003,
    d: "M575 1548v-157q169 -14 326 -111l-51 -227q-5 4 -14 11.5t-38.5 26.5t-60 35t-75 32.5t-87.5 23.5v-363q51 -32 74 -47t70 -48.5t71 -56t58.5 -60t51 -71.5t29.5 -78t13 -91q0 -163 -99 -268t-268 -122v-170h-124v168q-65 5 -126 21t-101.5 35.5t-72 38t-46.5 30.5 l-15 13l21 239l17 -17t46.5 -39.5t73 -51t93 -43.5t110.5 -27v377q-60 38 -98.5 65t-89.5 72t-81 86.5t-51.5 99t-21.5 119.5q0 154 92 263t250 130v162h124zM686 315q0 73 -111 152v-285q52 14 81.5 48.5t29.5 84.5zM352 1053q0 -74 99 -150v275q-43 -13 -71 -45t-28 -80z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 1761,
    d: "M793 1038q0 -136 -102 -234.5t-238 -98.5q-133 0 -233.5 99t-100.5 234t100.5 234.5t233.5 99.5q136 0 238 -99t102 -235zM612 1040q0 62 -48 108t-109 46q-63 0 -109.5 -45.5t-46.5 -108.5q0 -61 45.5 -112t110.5 -51q71 0 114 50t43 113zM1448 1325l-918 -1325h-239 l962 1409zM1642 307q0 -136 -101.5 -235t-237.5 -99q-133 0 -233.5 99.5t-100.5 234.5t100.5 234.5t233.5 99.5q136 0 237.5 -99t101.5 -235zM1462 309q0 62 -48 108t-109 46q-63 0 -109.5 -45.5t-46.5 -108.5q0 -61 45.5 -112.5t110.5 -51.5q71 0 114 50.5t43 113.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 1574,
    d: "M1516 113l-183 -158q-135 56 -309 186q-158 -168 -442 -168q-207 0 -338 112t-131 273q0 121 70 228.5t206 220.5q-170 250 -170 399q0 155 122.5 258t303.5 103q165 0 266 -83.5t101 -203.5q0 -61 -26.5 -122t-79 -122.5t-108.5 -113.5t-136 -117q145 -183 329 -352 q8 16 20 46.5t32 130t20 204.5q0 93 -8 194h497l-41 -182h-239q0 -164 -35.5 -307t-83.5 -222q202 -157 363 -204zM639 164q40 0 78.5 11t65.5 26.5t48 31t31 26.5l10 11q-172 152 -370 392q-129 -129 -129 -277q0 -93 65.5 -157t200.5 -64zM451 1233q0 -100 114 -283 q100 81 153.5 147.5t53.5 129.5q0 62 -39 114t-110 52q-63 0 -117.5 -42.5t-54.5 -117.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 493,
    d: "M346 874h-199l7 259l-37 204l229 39v-502z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 696,
    d: "M350 485q0 -129 21.5 -254.5t55.5 -222t74 -180t78.5 -139.5t67 -89t41.5 -40l-186 -68q-109 67 -202 232.5t-144.5 369t-51.5 391.5t52 378t144 338.5t202 215.5l186 -67q-18 -9 -53.5 -46t-85.5 -113.5t-93.5 -172.5t-74.5 -238t-31 -295z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 696,
    d: "M346 485q0 153 -31 295t-74.5 238t-93.5 172.5t-85.5 113.5t-53.5 46l187 67q110 -67 201 -215.5t143.5 -338.5t52.5 -378t-51.5 -392t-144 -369.5t-201.5 -231.5l-187 68q13 7 41.5 40t67 89t78.5 139.5t74 180t55.5 222t21.5 254.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 843,
    d: "M-23 1104l82 168l222 -6l-166 258l211 14l92 -178l125 229l137 -133l-125 -190l303 6l-82 -168l-221 6l166 -258l-211 -14l-92 176l-125 -226l-133 134l121 188z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 985,
    d: "M381 123v295h-293v200h293v316l225 -62v-254h309l-51 -200h-258v-295h-225z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 573,
    d: "M186 -272l-82 100q121 108 121 199q0 40 -13.5 59.5t-45.5 34.5v14q0 49 39.5 94t97.5 45q61 0 103.5 -41t42.5 -116q0 -83 -66 -190.5t-197 -198.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 638,
    d: "M33 612h596l-58 -213h-538v213z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 573,
    d: "M440 125q0 -64 -43 -108t-110 -44t-110.5 44t-43.5 108q0 61 44.5 107.5t109.5 46.5t109 -46.5t44 -107.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 616,
    d: "M586 1346l-439 -1846h-225l432 1846h232z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    d: "M535 1235q456 0 456 -629q0 -108 -16.5 -200.5t-54 -173.5t-95 -137.5t-143 -89t-193.5 -32.5q-93 0 -169.5 34.5t-137 107.5t-94 198.5t-33.5 294.5q0 136 28.5 248.5t85 198t150 133t216.5 47.5zM522 1038q-100 0 -151.5 -104.5t-51.5 -302.5q0 -107 9.5 -188.5 t31.5 -145.5t60 -97.5t92 -33.5q100 0 159.5 115t59.5 317q0 209 -51 324.5t-158 115.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 839,
    d: "M70 0v197h252v747l-201 -61l-74 182l528 174v-1042h252l-28 -197h-729z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    d: "M938 0h-788l-27 115q195 209 274 305q231 282 232 434q0 82 -47 127t-109 45q-40 0 -80.5 -13t-69.5 -31t-52.5 -36.5t-35.5 -31.5l-12 -13l-106 186q76 64 178 101t207 37q76 0 144.5 -22t123 -63.5t87 -108.5t32.5 -150q0 -86 -42.5 -185.5t-103.5 -180.5t-122 -149.5 t-103 -106.5l-43 -38h490z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    d: "M893 924q0 -83 -56 -155t-147 -118q117 -28 184.5 -127.5t67.5 -214.5q0 -82 -23 -154.5t-64 -128t-98 -100.5t-124.5 -72t-144 -44.5t-156 -16.5t-160.5 12l-61 193q63 -13 135 -14.5t150 14t140.5 48t103 93.5t40.5 144q0 61 -37.5 108t-92 71.5t-103.5 36t-85 11.5 l29 168q97 32 168.5 92t71.5 127q0 65 -46.5 99t-103.5 34q-35 0 -73.5 -11t-69.5 -27t-56.5 -32t-39 -28t-11.5 -14l-84 178q70 57 164.5 93t194.5 36q162 0 274.5 -79.5t112.5 -221.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    d: "M29 340l581 889l217 -37v-776h197l-41 -221h-156v-211l25 -189h-279v400h-518zM578 416v319l16 158l-74 -152l-162 -264l-45 -61h265z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    d: "M905 1198l-41 -221h-430l-10 -209q134 -1 248.5 -56.5t185 -159t70.5 -233.5q0 -108 -37.5 -197t-99.5 -149t-145.5 -101.5t-173.5 -60t-185 -18.5q-74 0 -129 8l-62 191q84 -15 152 -15q77 0 149 18.5t134 56t99.5 101.5t37.5 146q0 77 -55.5 144.5t-141.5 106 t-178 38.5q-53 0 -103 -6l29 616h686z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    d: "M977 1266l-86 -201q-47 53 -118 87t-142 34q-104 0 -191.5 -94.5t-101.5 -266.5q117 68 262 68q81 0 150.5 -23.5t125 -70.5t87.5 -127t32 -185q0 -143 -52 -258t-159.5 -185.5t-255.5 -70.5q-151 0 -256 83t-153.5 224t-48.5 330q0 173 30.5 308t82.5 222.5t126 144.5 t156 80.5t178 23.5q59 0 114.5 -12.5t93.5 -30.5t68 -36.5t44 -31.5zM514 686q-96 0 -184 -63q8 -443 233 -443q82 0 128 74.5t46 175.5q0 134 -61.5 195t-161.5 61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    d: "M428 -233l-229 32l516 1178h-586l-66 221h924l39 -53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    d: "M494 -27q-57 0 -112.5 10.5t-111.5 36t-98 63.5t-68 98.5t-26 135.5q0 64 20.5 121t62.5 107t81 85.5t100 82.5q-101 83 -158 160.5t-57 160.5q0 165 111 260t309 95q163 0 271 -79t108 -206q0 -61 -17 -113t-52 -96t-68.5 -75t-86.5 -72q64 -49 105.5 -86t85.5 -85 t66 -96.5t22 -97.5q0 -184 -138 -297t-349 -113zM494 608q-166 -118 -166 -258q0 -67 49 -117.5t135 -50.5q82 0 146.5 44t64.5 112q0 32 -17 64.5t-55 70.5t-68.5 63.5t-88.5 71.5zM555 854q125 91 125 207q0 56 -40 99.5t-116 43.5q-69 0 -110 -32.5t-41 -96.5 q0 -51 46 -102t136 -119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    d: "M74 -109l86 201q47 -53 118 -87t142 -34q103 0 191 108.5t102 295.5q-117 -68 -262 -68q-81 0 -150.5 23.5t-125.5 70.5t-88 127t-32 185q0 143 52 257.5t159.5 184.5t255.5 70q114 0 202.5 -50t144 -139t84 -207.5t28.5 -259.5q0 -173 -30.5 -310t-82.5 -227.5 t-126 -150.5t-156.5 -86t-177.5 -26q-59 0 -114.5 12.5t-93.5 30.5t-68 36t-44 30zM537 514q94 0 184 64q-8 440 -234 440q-82 0 -128 -73.5t-46 -174.5q0 -134 62 -195t162 -61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 548,
    d: "M139 662q0 60 42.5 101.5t101.5 41.5q56 0 96.5 -41.5t40.5 -101.5q0 -57 -40.5 -97.5t-96.5 -40.5q-59 0 -101.5 40.5t-42.5 97.5zM139 111q0 60 42.5 101.5t101.5 41.5q56 0 96.5 -41.5t40.5 -101.5q0 -57 -40.5 -97.5t-96.5 -40.5q-59 0 -101.5 40.5t-42.5 97.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 548,
    d: "M156 -272l-82 100q121 108 121 199q0 41 -13.5 60t-44.5 34q-2 4 -2 14q0 49 39.5 94t97.5 45q61 0 103.5 -41t42.5 -116q0 -83 -65.5 -190.5t-196.5 -198.5zM139 662q0 60 42.5 101.5t101.5 41.5q56 0 96.5 -41.5t40.5 -101.5q0 -57 -40.5 -97.5t-96.5 -40.5 q-59 0 -101.5 40.5t-42.5 97.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 776,
    d: "M702 821l-313 -317l313 -314l-92 -184l-551 500l551 500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 1003,
    d: "M88 412h815l-51 -193h-764v193zM88 791h836l-52 -193h-784v193z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 776,
    d: "M70 190l313 318l-313 313l92 185l551 -500l-551 -500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 899,
    d: "M416 389l-207 72q-10 40 -10 71q0 54 20 106.5t52.5 96t71.5 86t78 82.5t71.5 79t52.5 82.5t20 86.5q0 85 -61 131.5t-146 46.5q-36 0 -85 -11.5t-80 -23.5l-31 -12l-68 221q156 53 289 53q66 0 128 -13.5t119.5 -43t100 -73t67.5 -108.5t25 -144q0 -71 -31.5 -139.5 t-78 -121t-101.5 -107t-101.5 -99t-78 -95.5t-31.5 -98q0 -81 15 -125zM487 125q0 -64 -43 -108t-110 -44t-110.5 44t-43.5 108q0 61 44.5 107.5t109.5 46.5t109 -46.5t44 -107.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 1867,
    d: "M1280 831v-473v-34q0 -59 0.5 -86.5t5 -55.5t14.5 -39q62 0 113 41t81.5 106t47.5 139.5t17 148.5q0 124 -38 233.5t-110 194t-185 133.5t-253 49q-108 0 -211 -39.5t-185 -109.5t-144 -160t-96 -196.5t-34 -213.5q0 -98 29.5 -196t87.5 -186.5t138 -158t189 -112 t232 -47.5l-109 -187q-147 18 -273.5 76.5t-217.5 144t-155.5 193.5t-96 228t-31.5 245q0 132 37 261t113 244t182 203t254 139.5t319 51.5q167 0 311 -59.5t244.5 -161.5t158 -242.5t57.5 -298.5q0 -91 -20.5 -179.5t-64.5 -172t-107.5 -146.5t-156.5 -101t-204 -38 q-60 0 -93 4q-18 20 -38 59t-29 72q-3 -5 -8.5 -13t-26 -29t-44 -37.5t-61.5 -29.5t-79 -13q-81 0 -147 38t-107 101t-62.5 140t-21.5 159q0 274 163.5 445t424.5 171q42 0 94 -10t83 -20l31 -11zM1036 242l-2 614q-33 -7 -63.5 -19t-70 -42t-68 -73t-48.5 -115.5 t-20 -164.5q0 -65 11 -119t42 -94.5t78 -40.5q35 0 70 13.5t53 26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 1212,
    d: "M-20 0l526 1352l174 43l418 -1141l114 -254h-297l-116 317h-453l-121 -317h-245zM559 924l-147 -396h327l-141 398l-18 80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 1179,
    d: "M465 1178v-349q55 0 100 -1.5t66 -3.5t41.5 -4.5t25.5 -2.5q27 39 46.5 93t19.5 106q0 91 -50.5 128.5t-164.5 37.5q-22 0 -84 -4zM170 1368l367 10q222 0 348.5 -80t126.5 -241q0 -76 -49 -153t-113 -134q120 -55 183 -142.5t63 -197.5q0 -95 -30 -172t-90 -135.5 t-158 -90.5t-228 -32h-391v1157zM465 633v-434h127q112 0 172.5 59t60.5 164q0 98 -68 154.5t-216 56.5h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 1267,
    d: "M1219 1223l-109 -197q-161 164 -358 164q-113 0 -207 -71t-146.5 -189t-52.5 -254q0 -116 35.5 -211t95 -156t135.5 -94t160 -33q107 0 217 50t197 143l49 -211q-96 -88 -233 -139.5t-269 -51.5q-103 0 -199 27t-180.5 83t-147.5 135.5t-99.5 192t-36.5 244.5 q0 159 52.5 297t143.5 234.5t216.5 151.5t267.5 55q279 0 469 -170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 1398,
    d: "M170 1368h553q94 0 180.5 -24.5t164 -78t135 -131.5t91 -191.5t33.5 -250.5q0 -147 -47.5 -274.5t-132.5 -220t-210.5 -145t-274.5 -52.5h-463v1157zM465 1169v-970h221q156 0 258.5 137.5t102.5 343.5q0 210 -102.5 349.5t-258.5 139.5h-221z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    d: "M199 0v1157l-29 211h784v-203h-489v-362h432l-51 -203h-381v-397h516l-51 -203h-731z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 993,
    d: "M199 1157l-29 211h784v-203h-489v-362h432l-51 -203h-381v-424l22 -176h-288v1157z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 1343,
    d: "M1219 1223l-109 -197q-161 164 -358 164q-113 0 -207 -71t-146.5 -189t-52.5 -254q0 -116 36 -212.5t96 -159t135.5 -96.5t156.5 -34q48 0 101 7t81 13l29 7v288l-37 177h295l2 -603q-27 -10 -74 -25t-181 -40t-253 -25q-103 0 -199 27t-180.5 83t-147.5 135.5t-99.5 192 t-36.5 244.5q0 159 52.5 297t143.5 234.5t216.5 151.5t267.5 55q279 0 469 -170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 1566,
    d: "M1370 1368v-1192l23 -176h-289v578h-639v-402l22 -176h-288v1157l-29 211h295v-567h639v356l-29 211h295z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 673,
    d: "M467 1368v-1192l22 -176h-288v1157l-29 211h295z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 663,
    d: "M473 1368v-1270q0 -80 -16 -153t-51 -138t-85.5 -112.5t-125 -75t-164.5 -27.5q-55 0 -152 19l15 229q55 -30 137 -30q80 0 128 82t48 206v1059l-29 211h295z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 1210,
    d: "M465 176l22 -176h-288v1157l-29 211h295v-629l330 484l65 145h342l-477 -647l510 -721h-328l-442 668v-492z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 985,
    d: "M199 0v1157l-29 211h295v-1161h522l-51 -207h-737z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 1830,
    d: "M911 127l-428 588l-67 133v-672l22 -176h-258v1157l-28 211h210l572 -813l522 813h178v-1192l23 -176h-289v846l-59 -131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 1519,
    d: "M1341 1368v-1192l15 -176h-170l-690 776l-80 129v-729l22 -176h-258v1157l-28 211h204l672 -790l78 -127v706l-29 211h264z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 1413,
    d: "M719 1389q206 0 350.5 -90t213.5 -244.5t69 -360.5q0 -151 -51 -285t-138.5 -229.5t-210 -151t-260.5 -55.5q-195 0 -339.5 93.5t-217 250t-72.5 353.5q0 151 50.5 284.5t137.5 228.5t208.5 150.5t259.5 55.5zM346 682q0 -222 101 -366t262 -144t260.5 144t99.5 366 t-99.5 366t-260.5 144t-262 -144t-101 -366z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 1138,
    d: "M170 1368h424q95 0 180 -26.5t153.5 -77t109 -134t40.5 -188.5q0 -121 -71 -226t-199 -169t-283 -64h-59v-307l22 -176h-288v1157zM465 688h92q99 0 171.5 73.5t72.5 180.5q0 111 -70 169t-174 58h-92v-481z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 1413,
    d: "M608 -131v111q-256 29 -400.5 219t-144.5 469q0 201 85.5 365t236 257.5t334.5 93.5q155 0 276.5 -51t199 -143t117.5 -218t40 -280q0 -266 -147.5 -461t-377.5 -243l435 -166l-97 -209zM346 680q0 -146 45 -263.5t128.5 -186t189.5 -68.5q160 0 260 147.5t100 370.5 t-100 370.5t-260 147.5q-106 0 -189.5 -68.5t-128.5 -186t-45 -263.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 1239,
    d: "M1243 0h-334l-340 483h-104v-307l22 -176h-288v1157l-29 211h424q95 0 180 -26.5t153.5 -77t109 -134t40.5 -188.5q0 -115 -72 -228t-186 -171zM465 678h92q98 0 171 78t73 186q0 112 -70.5 175t-173.5 63h-92v-502z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 1003,
    d: "M90 113l21 229q7 -7 19.5 -18.5t53 -40.5t83 -51.5t105 -41t122.5 -18.5q83 0 137.5 50t54.5 120q0 47 -32 87.5t-83.5 73t-113.5 65.5t-124 72t-113.5 85.5t-83.5 114.5t-32 149q0 171 114.5 287.5t301.5 116.5q216 0 381 -103l-51 -205q-6 5 -16 12.5t-44 27t-71 34.5 t-93 27t-112 12q-61 0 -113.5 -44.5t-52.5 -111.5q0 -48 32.5 -88.5t84.5 -72.5t114.5 -64t125 -71.5t114.5 -86t84.5 -117t32.5 -155.5q0 -178 -117.5 -296t-310.5 -118q-74 0 -144.5 14.5t-118 35t-84 41t-53.5 34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 1138,
    d: "M0 1161v207h1139v-207h-443v-985l23 -176h-289v1161h-430z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 1466,
    d: "M1083 526v631l-28 211h264v-819q0 -259 -160.5 -417.5t-429.5 -158.5q-107 0 -194 28t-141.5 69t-95 98.5t-60 106.5t-30.5 102.5t-13 77.5t-2 41v661l-29 211h295v-856q0 -152 86.5 -245t220.5 -93q135 0 226 100t91 252z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 1273,
    d: "M1274 1368l-547 -1395l-186 41l-408 1100l-133 254h328l299 -858l30 -162l43 162l318 858h256z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 1970,
    d: "M1970 1368l-547 -1395l-186 41l-240 637l-270 -678l-186 41l-408 1100l-133 254h328l301 -858l28 -162l43 162l181 455l-150 403h293l301 -858l29 -162l43 162l317 858h256z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 1097,
    d: "M0 0l418 684l-281 506l-131 178h326l209 -385l30 -72l27 72l221 385h271l-398 -651l406 -717h-299l-224 416l-32 71l-29 -71l-231 -416h-283z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 1126,
    d: "M707 612v-436l22 -176h-289v592l-313 602l-127 174h326l241 -467l27 -80l27 80l239 467h266z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 1179,
    d: "M49 0l-10 72l625 981l84 106h-678l55 209h987l10 -72l-620 -981l-84 -108h727v-207h-1096z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 528,
    d: "M442 1503v-178h-176v-1286h176v-180h-411v1644h411z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 749,
    d: "M537 -500l-543 1846h237l527 -1846h-221z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 528,
    d: "M74 1325v178h411v-1644h-411v180h176v1286h-176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 1298,
    d: "M1192 655h-231l-316 576l-317 -576h-226l457 795h176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 1009,
    d: "M1053 -133l-68 -164h-985v164h1053z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 712,
    d: "M47 1483h305l236 -279l-162 -57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 1071,
    d: "M227 729l-104 180q6 6 18 16.5t53 37.5t87 47.5t119.5 37.5t150.5 17q53 0 101.5 -8.5t94.5 -30t79.5 -53t54 -80.5t20.5 -111v-530q0 -55 26.5 -116.5t52.5 -95.5l26 -34l-258 -29q-52 57 -70 127q-61 -61 -143 -96t-166 -35q-129 0 -214 81t-85 188q0 166 155 277 t422 120v39q0 205 -139 205q-45 0 -91 -16t-78.5 -38.5t-59 -45t-39.5 -38.5zM453 162q46 0 102.5 26.5t91.5 61.5v209q-315 -25 -315 -185q0 -46 31.5 -79t89.5 -33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 1144,
    d: "M133 1526l283 30v-567q11 9 31 21.5t79 33.5t115 21q83 0 159.5 -33.5t138.5 -96.5t99 -165t37 -229q0 -152 -67.5 -281.5t-192.5 -208t-280 -78.5q-125 0 -231.5 53t-141.5 126v1167zM416 819v-604q60 -57 151 -57q97 0 166.5 105.5t69.5 258.5q0 151 -68.5 248.5 t-167.5 97.5q-37 0 -75 -12t-57 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 1001,
    d: "M956 928l-116 -185q-53 66 -120.5 96.5t-131.5 30.5q-84 0 -143 -50.5t-85 -128t-26 -173.5q0 -90 25.5 -164t83 -123t137.5 -49q50 0 103 17t92.5 41t72.5 48t50 41l17 17l37 -213q-6 -7 -18 -17.5t-53 -38t-86.5 -48.5t-117.5 -38.5t-147 -17.5q-110 0 -199 45 t-144 120t-84 168t-29 194q0 113 33.5 214.5t96 180t160.5 124.5t218 46q71 0 135.5 -14t106 -34.5t73 -40.5t45.5 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    horizAdvX: 1150,
    d: "M983 1571v-1317q0 -55 26 -116.5t52 -95.5l26 -34l-258 -28q-44 42 -69 120q-47 -52 -129.5 -88.5t-151.5 -36.5q-83 0 -156.5 34.5t-130 99t-89.5 165t-33 224.5q0 152 67.5 281.5t192.5 207.5t280 78l119 -10v278l-29 207zM545 166q74 0 184 96v608q-71 13 -151 13 q-97 0 -166.5 -107t-69.5 -260q0 -162 58 -256t145 -94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 1021,
    d: "M561 1065q74 0 134 -22.5t99 -56.5t69 -84.5t45.5 -96.5t25 -104t12.5 -94.5t4 -78.5l-49 -49h-567q8 -131 74 -214t182 -83q50 0 103.5 15t95 36.5t75.5 43t52 36.5l18 15l37 -209q-7 -6 -19.5 -16t-55 -35t-89 -44t-119.5 -35t-147 -16q-111 0 -201 43.5t-147.5 117 t-88 166t-30.5 192.5q0 116 28.5 216.5t86 181.5t153 128t219.5 47zM537 891q-80 0 -127 -63.5t-66 -168.5h342q-3 41 -11 78.5t-24.5 73.5t-45.5 58t-68 22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 692,
    d: "M51 844v190h125v123q0 108 27 188.5t75 127.5t107 69.5t129 22.5q135 0 270 -78l-86 -207q-83 66 -163 66q-48 0 -76.5 -36.5t-28.5 -115.5v-160h258l-67 -190h-191v-611l23 -233h-277v844h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 1056,
    d: "M498 248q-37 0 -69 5t-45 10l-13 5q-43 -43 -43 -80q0 -31 38 -44.5t99 -15t135 -2t148 -11t135 -34.5t99 -80.5t38 -141.5q0 -87 -46 -157t-121.5 -112.5t-167.5 -65t-191 -22.5q-77 0 -143 12t-110.5 31.5t-80.5 42.5t-56.5 46.5t-34.5 43t-19 31.5l-5 12l148 136 q3 -7 8.5 -18.5t31 -41t58 -52.5t93 -41.5t132.5 -18.5q48 0 92 6.5t84 21t64 41t24 62.5q0 40 -36.5 61t-95.5 25.5t-129.5 5.5t-141.5 7t-130 22t-95.5 58.5t-36.5 110.5q0 99 127 226q-71 46 -119.5 133t-48.5 180q0 181 126 300.5t320 119.5q56 0 120 -21t81 -36l37 26 h299l-43 -157h-144q70 -87 70 -215q0 -181 -126.5 -297.5t-315.5 -116.5zM334 655q0 -100 52.5 -164.5t123.5 -64.5t120.5 64t49.5 165q0 102 -49.5 167t-120.5 65t-123.5 -65.5t-52.5 -166.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 1208,
    d: "M1077 0h-276v598q0 149 -24.5 201.5t-100.5 52.5q-44 0 -86.5 -11.5t-71.5 -28t-52.5 -33.5t-34.5 -29l-11 -11v-563l22 -176h-276v1319l-29 207l283 30v-614q66 60 152 91.5t173 31.5q60 0 114.5 -16.5t98.5 -47.5t70.5 -82.5t26.5 -115.5v-631z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 581,
    d: "M416 1065v-889l22 -176h-276v827l-29 207zM141 1337q0 60 42.5 102t101.5 42q56 0 96.5 -42t40.5 -102q0 -57 -40.5 -97t-96.5 -40q-59 0 -101.5 40t-42.5 97z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 569,
    d: "M418 1065v-1030q0 -236 -116.5 -384.5t-295.5 -150.5l-88 211q134 0 190 91t56 255v770l-29 207zM141 1337q0 60 42.5 102t101.5 42q56 0 96.5 -42t40.5 -102q0 -57 -40.5 -97t-96.5 -40q-59 0 -101.5 40t-42.5 97z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 1112,
    d: "M420 1556v-989l280 357l50 110h342l-416 -469l436 -565h-317l-375 518v-342l22 -176h-276v1319l-29 207z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 585,
    d: "M420 1556v-1380l22 -176h-276v1319l-29 207z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 1847,
    d: "M1710 0h-276v598q0 149 -24.5 201.5t-100.5 52.5q-43 0 -84.5 -12t-71 -29t-52.5 -34.5t-35 -29.5l-11 -12v-563l22 -172h-276v598q0 149 -24.5 201.5t-100.5 52.5q-69 0 -133 -30t-93 -60l-30 -29v-557l22 -176h-276v825l-29 207l283 31v-127q67 61 153.5 95t171.5 34 q87 0 163.5 -38t115.5 -105q3 5 16 17.5t44.5 35t70.5 42t99 34t124 14.5q60 0 114.5 -16.5t98.5 -47.5t70.5 -82.5t26.5 -115.5v-631z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 1214,
    d: "M1077 0h-276v598q0 149 -24.5 201.5t-100.5 52.5q-44 0 -86.5 -12t-71.5 -29t-52.5 -34.5t-34.5 -29.5l-11 -12v-559l22 -176h-276v825l-29 207l283 31v-125q67 61 153 94t172 33q60 0 114.5 -16.5t98.5 -47.5t70.5 -82.5t26.5 -115.5v-631z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 1153,
    d: "M1083 541q0 -115 -37 -217.5t-104.5 -180.5t-170.5 -124t-228 -46q-90 0 -168 30.5t-133 82t-94.5 120t-58.5 144.5t-19 154q0 115 36.5 216.5t103.5 178.5t171 121.5t231 44.5q212 0 341.5 -132t129.5 -392zM340 520q0 -158 63.5 -261t171.5 -103t172 103t64 261 t-64 260.5t-172 102.5t-171.5 -102.5t-63.5 -260.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 1155,
    d: "M166 -492v1319l-29 207l283 31v-115q124 115 250 115q83 0 156.5 -34.5t130 -99t89.5 -165.5t33 -225q0 -152 -67.5 -281.5t-192.5 -208t-280 -78.5q-27 0 -119 9v-297l22 -177h-276zM604 854q-51 0 -97 -21.5t-67 -42.5l-20 -22v-602q71 -8 151 -8q97 0 166.5 105.5 t69.5 258.5q0 160 -57.5 246t-145.5 86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 1130,
    d: "M1001 -502h-272v531q-103 -56 -209 -56q-87 0 -166 32.5t-143 94.5t-102.5 165.5t-38.5 234.5q0 152 67.5 281t192.5 206.5t280 77.5q56 0 149 -10.5t159 -20.5l65 -10v-1317zM729 207v661q-80 13 -151 13q-97 0 -166.5 -105t-69.5 -258t69.5 -258.5t166.5 -105.5 q88 0 151 53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 868,
    d: "M868 989l-77 -225q-7 6 -19 15t-48 24.5t-71 15.5q-83 0 -158 -87.5t-75 -203.5v-352l22 -176h-276v823l-29 207l283 31v-187q4 8 12 21t34.5 45.5t56.5 58t77.5 46t97.5 20.5q97 0 170 -76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 874,
    d: "M70 94l24 215q7 -6 19 -15.5t49.5 -34t74 -43.5t87.5 -34.5t96 -15.5q61 0 105 26.5t44 75.5q0 32 -27.5 60t-71 50t-96.5 45t-106.5 51.5t-97 62.5t-71 84.5t-27.5 111.5q0 73 22.5 130.5t60.5 94.5t91 61t110 34t123 10q80 0 153 -17t106 -34l34 -17l-47 -204 q-4 4 -12 10t-36 22t-59 28t-80.5 22t-101.5 10q-53 0 -92 -28t-39 -69q0 -29 21.5 -54.5t56.5 -44t80 -39.5t92 -41t92 -49.5t80 -64t56.5 -85.5t21.5 -113q0 -154 -104.5 -238t-282.5 -84q-65 0 -125 12.5t-99 30.5t-68.5 35.5t-42.5 30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 776,
    d: "M451 1247l-21 -213h305l-65 -190h-242v-545q0 -94 86 -94q53 0 125 31t111 65l26 -223q-5 -4 -14 -11t-41 -25.5t-68 -32t-94.5 -25t-120.5 -11.5q-134 0 -198 78t-64 254v539h-125v190h125v183z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 1212,
    d: "M1149 10l-266 -37q-52 66 -66 140q-6 -6 -16 -15.5t-45 -33.5t-73.5 -42.5t-97.5 -33.5t-120 -15q-81 0 -149.5 27.5t-114 89t-45.5 146.5v589l-29 207l283 31v-623q0 -144 22.5 -200t95.5 -56q46 0 90.5 13t74.5 32t53 37.5t34 31.5l11 13v514l-29 207l282 31v-807 q0 -34 11 -72t26 -68t30.5 -54.5t26.5 -37.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 1050,
    d: "M1051 1063l-447 -1090l-221 39l-283 824l-100 190l287 37l209 -660l22 -137l33 137l227 621z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 1726,
    d: "M1726 1063l-446 -1090l-209 39l-186 543l-27 102l-22 -104l-244 -580l-209 39l-283 824l-100 190l281 37l208 -662l23 -135l37 135l201 527l-41 98l260 37l209 -662l22 -135l35 135l225 623z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 1052,
    d: "M0 0l383 516l-219 336l-150 174l295 37l193 -318l24 -55l29 55l197 281l301 37l-404 -526l355 -537h-291l-183 303l-28 53l-27 -55l-205 -301h-270z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 1050,
    d: "M1051 1063l-506 -1243q-65 -160 -170.5 -239t-235.5 -79q-75 0 -147 29l-35 246q84 -35 152 -35q92 0 158 59t118 205l-285 825l-100 191l283 37l213 -656l22 -137l35 137l229 621z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 931,
    d: "M29 0l-9 59l453 703l66 82h-506l53 190h797l8 -59l-453 -705l-63 -80h526v-190h-872z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 636,
    d: "M25 539v147q45 0 75.5 17.5t43 45t16.5 46t4 34.5v392q0 108 56 182.5t146.5 108.5t208.5 34v-168q-165 0 -165 -164v-383q0 -41 -12 -78.5t-29 -62t-33.5 -43t-28.5 -27.5l-12 -8q5 -3 12.5 -9t27.5 -26.5t35 -44t27.5 -61t12.5 -78.5v-557q0 -164 165 -164v-168 q-118 0 -208.5 34t-146.5 109t-56 183v565q0 12 -2 26t-10 36t-22 39.5t-41.5 30t-63.5 12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 485,
    d: "M356 1548v-2068h-227v2068h227z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 636,
    d: "M612 686v-147q-36 0 -63.5 -12.5t-41.5 -30t-22 -39.5t-10 -36t-2 -26v-565q0 -108 -56 -183t-147 -109t-209 -34v168q166 0 166 164v557q0 41 12 78.5t28.5 62t33.5 43t29 27.5l12 8q-5 3 -12.5 9t-27.5 26.5t-35 44t-27.5 61t-12.5 78.5v383q0 164 -166 164v168 q118 0 209 -34t147 -108.5t56 -182.5v-392q0 -16 4 -34.5t16.5 -46t43 -45t75.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 1204,
    d: "M1047 713l92 -183q-59 -61 -146.5 -99t-179.5 -38q-57 0 -119.5 18t-108.5 39.5t-105.5 39.5t-112.5 18q-131 0 -213 -94l-84 180q154 131 315 131q64 0 129 -18t109.5 -39.5t99 -39.5t98.5 -18q110 0 226 103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 561,
    d: "M127 -221l57 1124l189 31l43 -924l28 -190zM121 1223q0 64 43 107.5t110 43.5t110.5 -43.5t43.5 -107.5q0 -61 -44.5 -107.5t-109.5 -46.5t-109 46.5t-44 107.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    horizAdvX: 1007,
    d: "M657 1217v-156q58 -6 111 -23t87 -36.5t59.5 -38t37.5 -31.5l11 -12l-129 -164q-70 86 -177 108v-667q64 15 130.5 53.5t100.5 69.5l34 32l36 -219q-5 -5 -13.5 -12.5t-38 -28.5t-62 -39.5t-83.5 -37.5t-104 -29v-179h-125v166q-110 1 -198 46t-142.5 120t-83 167.5 t-28.5 193.5q0 143 50.5 263.5t154.5 202t247 95.5v156h125zM340 518q0 -122 49 -212.5t143 -112.5v669q-95 -25 -143.5 -120.5t-48.5 -223.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    horizAdvX: 1144,
    d: "M1087 -209h-1044q7 15 18.5 41.5t40.5 106.5t51.5 159.5t41 187t18.5 201.5v52h-125v180h125v397q0 85 31.5 158t81.5 121.5t112.5 83t123.5 50t116 15.5q77 0 147 -13.5t114.5 -33t78.5 -38.5t48 -33l15 -13l-73 -192q-46 48 -135.5 90.5t-172.5 42.5 q-98 0 -162.5 -55.5t-64.5 -165.5v-414h418l-66 -180h-352v-70q0 -98 -24.5 -219.5t-48.5 -193.5l-25 -72h764z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    horizAdvX: 1126,
    d: "M180 731h187l-240 461l4 -2l-131 178h326l241 -467l27 -80l31 80l241 467h260l-356 -637h231l-36 -172h-258v-162h274l-37 -172h-237v-49l22 -176h-289v225h-260v172h260v162h-260v172z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 880,
    d: "M588 1348l160 -1102q38 -253 38 -269q0 -106 -58.5 -185.5t-151.5 -119t-203 -39.5q-65 0 -121.5 16t-90.5 39t-58.5 46t-34.5 39l-9 16l13 199q113 -137 241 -156q-198 1272 -198 1368q0 105 58 185t150.5 120.5t202.5 40.5q65 0 121.5 -16t90.5 -39t58.5 -45.5 t33.5 -38.5l10 -16l-13 -199q-114 137 -239 156zM315 1200q2 -65 195 -1337q72 47 72 117q0 69 -197 1339q-70 -43 -70 -119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 806,
    d: "M334 1305q0 -52 -34.5 -88.5t-80.5 -36.5t-80.5 36.5t-34.5 88.5t34.5 89.5t80.5 37.5t80.5 -37.5t34.5 -89.5zM711 1305q0 -52 -34.5 -88.5t-80.5 -36.5q-47 0 -81 36.5t-34 88.5t34 89.5t81 37.5q46 0 80.5 -37.5t34.5 -89.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 1638,
    d: "M1106 969l-76 -148q-11 10 -29.5 24.5t-70.5 39t-96 24.5q-73 0 -121.5 -63.5t-48.5 -159.5q0 -95 50 -163t130 -68q50 0 109 25t93 50l33 25l21 -162q-4 -4 -13 -11.5t-38.5 -25.5t-62.5 -32.5t-85.5 -26t-107.5 -12.5q-107 -1 -185.5 54.5t-115.5 140t-37 184.5 q0 174 100 291.5t283 117.5q65 0 132 -26t102 -52zM1536 696q0 -331 -201.5 -527t-548.5 -196q-193 0 -350 90t-245.5 247t-88.5 349q0 328 206.5 518.5t561.5 190.5q192 0 344.5 -87t237 -240.5t84.5 -344.5zM1348 670q0 244 -146 393t-375 149q-109 0 -206 -36.5 t-169.5 -102.5t-114.5 -167t-42 -222q0 -254 145 -402.5t391 -148.5q140 0 257 64.5t188.5 188.5t71.5 284z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 849,
    d: "M180 1120l-96 127q5 5 13.5 14.5t40 32.5t67.5 41t94.5 32.5t122.5 14.5q55 0 102 -11t86 -34.5t61.5 -65t22.5 -97.5v-392q0 -37 20.5 -81.5t41.5 -70.5l20 -26l-229 -24q-5 4 -12.5 12.5t-21.5 34t-17 51.5q-80 -100 -191 -100q-119 0 -184.5 63t-65.5 147 q0 112 110 188.5t304 86.5v43q0 65 -24 95t-62 30q-34 0 -67.5 -11.5t-56.5 -27.5t-42 -32.5t-28 -27.5zM469 797v137q-26 -4 -39.5 -6.5t-41 -8.5t-44 -14.5t-34.5 -21t-27 -31t-9 -41.5q0 -31 22.5 -57.5t55.5 -26.5q47 0 117 70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 1314,
    d: "M694 821l-313 -317l313 -314l-92 -184l-551 500l551 500zM1243 821l-313 -317l313 -314l-92 -184l-551 500l551 500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    horizAdvX: 1095
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 1638,
    d: "M1196 319h-248l-182 269v-162q0 -14 14 -107h-221v611l-14 131h254q121 0 206 -63.5t85 -178.5q0 -60 -40.5 -120t-103.5 -89zM766 686h8q52 0 91.5 35t39.5 98q0 61 -38 88t-93 27h-8v-248zM1536 696q0 -331 -201.5 -527t-548.5 -196q-193 0 -350 90t-245.5 247 t-88.5 349q0 328 206.5 518.5t561.5 190.5q192 0 344.5 -87t237 -240.5t84.5 -344.5zM1348 670q0 244 -146 393t-375 149q-109 0 -206 -36.5t-169.5 -102.5t-114.5 -167t-42 -222q0 -254 145 -402.5t391 -148.5q140 0 257 64.5t188.5 188.5t71.5 284z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    horizAdvX: 706,
    d: "M78 1362h561l-53 -201h-508v201z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 837,
    d: "M748 1180q0 -139 -105 -240.5t-244 -101.5q-136 0 -239 102t-103 240t103 240t239 102q139 0 244 -101.5t105 -240.5zM563 1182q0 63 -49.5 110t-112.5 47q-65 0 -112 -46.5t-47 -110.5q0 -63 46.5 -115.5t112.5 -52.5q72 0 117 51.5t45 116.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    horizAdvX: 985,
    d: "M381 328v233h-293v201h293v276l225 -61v-215h309l-51 -201h-258v-233h-225zM137 213h721l-57 -213h-664v213z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twosuperior",
    unicode: "\xB2",
    horizAdvX: 727,
    d: "M647 586h-545l-16 96l39 39t63 64.5t66.5 76t67 88t45.5 84.5t20 82q0 88 -74 88q-68 0 -145 -61l-84 147q52 47 122 73t144 26q72 0 131.5 -25t99.5 -82t40 -137q0 -151 -244 -389h287z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threesuperior",
    unicode: "\xB3",
    horizAdvX: 731,
    d: "M621 1190q0 -45 -36 -89.5t-87 -72.5q64 -10 108.5 -68t44.5 -126q0 -57 -25.5 -103t-66.5 -74.5t-96 -47.5t-110 -26.5t-113 -7.5q-59 0 -123 11l-45 143q70 -8 108 -8q106 0 176 32.5t70 104.5q0 31 -33 50.5t-73.5 25.5t-88.5 6l15 94q35 15 54.5 25t44 27.5t35.5 39 t11 48.5q0 37 -23 53t-57 16q-36 0 -75 -14.5t-60 -28.5l-20 -14l-58 125q4 3 11.5 8t32.5 18t52.5 23t70 18t85.5 8q110 0 190.5 -52t80.5 -144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 712,
    d: "M373 1483h305l-379 -336l-162 57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "mu",
    unicode: "\xB5",
    horizAdvX: 1062
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 1335,
    d: "M88 758q0 169 86 309.5t233.5 220.5t323.5 80h154v-1868h-195v650q-124 9 -235 59t-191.5 129.5t-128 189t-47.5 230.5zM1212 1368v-1868h-194v1868h194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 548,
    d: "M412 502q0 -64 -43.5 -108t-110.5 -44t-110.5 44t-43.5 108q0 61 44 107t110 46t110 -46t44 -107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 843,
    d: "M256 -100l25 106h125q21 -26 65.5 -57.5t81 -54.5t65.5 -61t29 -81q0 -78 -40 -132.5t-100.5 -77.5t-135.5 -23q-124 0 -240 80l62 141q33 -33 83 -48.5t91 -15.5q75 0 75 56q0 20 -24 42.5t-54 40t-62.5 41t-45.5 44.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onesuperior",
    unicode: "\xB9",
    horizAdvX: 638,
    d: "M86 586v145h154v418l-113 -35l-55 139l391 125v-647h155l-20 -145h-512z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 925,
    d: "M68 967q0 183 111 296t300 113q162 0 261.5 -95.5t99.5 -285.5q0 -176 -111.5 -298t-300.5 -122q-72 0 -130.5 21t-95 52t-63.5 74t-40 80t-21 77t-9 58t-1 30zM307 981q0 -110 39.5 -182t106.5 -72t107 72t40 182q0 109 -39.5 176.5t-107.5 67.5t-107 -67.5t-39 -176.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 1314,
    d: "M934 504l-313 317l92 185l551 -500l-551 -500l-92 184zM385 504l-313 317l92 185l551 -500l-551 -500l-92 184z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 1531,
    d: "M1264 1145l-666 -963h-209l707 1026zM86 586v145h154v418l-113 -35l-55 139l391 125v-647h155l-20 -145h-512zM801 162l379 545l182 -54v-430h143l-39 -162h-104v-53l16 -129h-235v182h-322zM1145 223l-4 178l6 76l-37 -76l-98 -145l-41 -37l43 4h131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 1613,
    d: "M1534 -121h-545l-16 96l32 32t50.5 51.5t57 61.5t60 73t50 73.5t38 75.5t13.5 68q0 88 -74 88q-67 0 -145 -62l-84 148q109 98 266 98q72 0 131.5 -25t99 -82t39.5 -137q0 -152 -243 -389h286zM1264 1145l-666 -963h-209l707 1026zM86 586v145h154v418l-113 -35l-55 139 l391 125v-647h155l-20 -145h-512z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 1499,
    d: "M768 162l379 545l182 -54v-430h144l-39 -162h-105v-53l17 -129h-236v182h-322zM1112 223l-4 178l6 76l-37 -76l-98 -145l-41 -37l43 4h131zM1231 1145l-666 -963h-209l707 1026zM621 1190q0 -45 -36 -89.5t-87 -72.5q64 -10 108.5 -68t44.5 -126q0 -57 -25.5 -103 t-66.5 -74.5t-96 -47.5t-110 -26.5t-113 -7.5q-59 0 -123 11l-45 143q70 -8 108 -8q106 0 176 32.5t70 104.5q0 31 -33 50.5t-73.5 25.5t-88.5 6l15 94q35 15 54.5 25t44 27.5t35.5 39t11 48.5q0 37 -23 53t-57 16q-36 0 -75 -14.5t-60 -28.5l-20 -14l-58 125q4 3 11.5 8 t32.5 18t52.5 23t70 18t85.5 8q110 0 190.5 -52t80.5 -144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 899,
    d: "M479 928l209 33q27 -89 27 -150q0 -51 -21 -100t-54.5 -89t-74.5 -79.5t-81.5 -79t-74 -79.5t-54.5 -88t-21 -99q0 -86 61 -132.5t146 -46.5q36 0 82.5 17t74.5 34l29 17l78 -221q-125 -66 -289 -66q-84 0 -160 21t-140 64t-102 117.5t-38 172.5q0 72 23 136t60 111.5 t81.5 90.5t89 81t81.5 74.5t60 79.5t23 87q0 50 -15 94zM412 1223q0 64 43 107.5t110 43.5t110.5 -43.5t43.5 -107.5q0 -61 -44.5 -107.5t-109.5 -46.5t-109 46.5t-44 107.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 1212,
    d: "M-20 0l526 1352l174 43l418 -1141l114 -254h-297l-116 317h-453l-121 -317h-245zM559 924l-147 -396h327l-141 398l-18 80zM238 1792h305l235 -279l-162 -57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 1212,
    d: "M-20 0l526 1352l174 43l418 -1141l114 -254h-297l-116 317h-453l-121 -317h-245zM559 924l-147 -396h327l-141 398l-18 80zM670 1772h305l-379 -336l-162 57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 1212,
    d: "M-20 0l526 1352l174 43l418 -1141l114 -254h-297l-116 317h-453l-121 -317h-245zM559 924l-147 -396h327l-141 398l-18 80zM494 1792h208l234 -272l-160 -62l-180 191l-176 -191l-160 62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 1212,
    d: "M-20 0l526 1352l174 43l418 -1141l114 -254h-297l-116 317h-453l-121 -317h-245zM559 924l-147 -396h327l-141 398l-18 80zM852 1702l111 -80q-2 -6 -6 -15.5t-21 -34.5t-40 -44.5t-66 -35t-95 -15.5q-54 0 -103.5 17.5t-86 34.5t-58.5 17q-41 0 -74.5 -17t-46.5 -35 l-14 -17l-106 75q2 6 7 16t24.5 36t43.5 46t66.5 36t91.5 16q45 0 92 -18t85 -36t63 -18q98 0 133 72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 1212,
    d: "M-20 0l526 1352l174 43l418 -1141l114 -254h-297l-116 317h-453l-121 -317h-245zM559 924l-147 -396h327l-141 398l-18 80zM524 1614q0 -52 -34 -88.5t-80 -36.5t-80.5 36.5t-34.5 88.5t34.5 89.5t80.5 37.5t80 -37.5t34 -89.5zM901 1614q0 -52 -34.5 -88.5t-80.5 -36.5 q-47 0 -80.5 36.5t-33.5 88.5q0 53 33.5 90t80.5 37q46 0 80.5 -37.5t34.5 -89.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 1212,
    d: "M-20 0l526 1352l174 43l418 -1141l114 -254h-297l-116 317h-453l-121 -317h-245zM559 924l-147 -396h327l-141 398l-18 80zM784 1620q0 -73 -56 -126.5t-130 -53.5q-73 0 -127.5 53.5t-54.5 126.5t54.5 126.5t127.5 53.5q74 0 130 -53.5t56 -126.5zM688 1622 q0 35 -27 61.5t-61 26.5q-36 0 -62 -26t-26 -62t25.5 -66t62.5 -30q40 0 64 29.5t24 66.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 1589,
    d: "M743 0v336h-352l-160 -336h-251l665 1368h854v-203h-489v-362h432l-51 -203h-381v-397h516l-51 -203h-732zM481 528h262v582z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 1267,
    d: "M1219 1223l-109 -197q-161 164 -358 164q-113 0 -207 -71t-146.5 -189t-52.5 -254q0 -116 35.5 -211t95 -156t135.5 -94t160 -33q107 0 217 50t197 143l49 -211q-96 -88 -233 -139.5t-269 -51.5q-103 0 -199 27t-180.5 83t-147.5 135.5t-99.5 192t-36.5 244.5 q0 159 52.5 297t143.5 234.5t216.5 151.5t267.5 55q279 0 469 -170zM598 -100l25 106h125q21 -26 65.5 -57.5t81 -54.5t65.5 -61t29 -81q0 -78 -40 -132.5t-100.5 -77.5t-135.5 -23q-124 0 -240 80l62 141q33 -33 83 -48.5t91 -15.5q75 0 75 56q0 20 -24 42.5t-54 40 t-62.5 41t-45.5 44.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    d: "M199 0v1157l-29 211h784v-203h-489v-362h432l-51 -203h-381v-397h516l-51 -203h-731zM211 1792h305l236 -279l-162 -57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    d: "M199 0v1157l-29 211h784v-203h-489v-362h432l-51 -203h-381v-397h516l-51 -203h-731zM643 1772h305l-379 -336l-161 57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    d: "M199 0v1157l-29 211h784v-203h-489v-362h432l-51 -203h-381v-397h516l-51 -203h-731zM467 1792h209l233 -272l-159 -62l-181 191l-176 -191l-160 62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    d: "M199 0v1157l-29 211h784v-203h-489v-362h432l-51 -203h-381v-397h516l-51 -203h-731zM498 1614q0 -52 -34.5 -88.5t-80.5 -36.5t-80.5 36.5t-34.5 88.5t34.5 89.5t80.5 37.5t80.5 -37.5t34.5 -89.5zM874 1614q0 -52 -34 -88.5t-80 -36.5q-47 0 -81 36.5t-34 88.5t34 89.5 t81 37.5q46 0 80 -37.5t34 -89.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 673,
    d: "M467 1368v-1192l22 -176h-288v1157l-29 211h295zM-23 1792h306l235 -279l-162 -57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 673,
    d: "M467 1368v-1192l22 -176h-288v1157l-29 211h295zM410 1772h305l-379 -336l-162 57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 673,
    d: "M467 1368v-1192l22 -176h-288v1157l-29 211h295zM233 1792h209l234 -272l-160 -62l-180 191l-176 -191l-160 62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 673,
    d: "M467 1368v-1192l22 -176h-288v1157l-29 211h295zM264 1614q0 -52 -34 -88.5t-80 -36.5t-80.5 36.5t-34.5 88.5t34.5 89.5t80.5 37.5t80 -37.5t34 -89.5zM641 1614q0 -52 -34.5 -88.5t-80.5 -36.5q-47 0 -80.5 36.5t-33.5 88.5q0 53 33.5 90t80.5 37q46 0 80.5 -37.5 t34.5 -89.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 1398,
    d: "M49 803h150v354l-29 211h553q94 0 180.5 -24.5t164 -78t135 -131.5t91 -191.5t33.5 -250.5q0 -147 -47.5 -274.5t-132.5 -220t-210.5 -145t-274.5 -52.5h-463v590h-150v213zM465 1178v-375h262l-57 -213h-205v-391h221q156 0 258.5 137.5t102.5 343.5q0 138 -46 252 t-129 180t-186 66h-221z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 1519,
    d: "M1341 1368v-1192l15 -176h-170l-690 776l-80 129v-729l22 -176h-258v1157l-28 211h204l672 -790l78 -127v706l-29 211h264zM1004 1702l110 -80q-2 -6 -5.5 -15.5t-21 -34.5t-40 -44.5t-65.5 -35t-95 -15.5q-54 0 -103.5 17.5t-86 34.5t-58.5 17q-41 0 -74.5 -17 t-46.5 -35l-14 -17l-107 75q2 6 7 16t24.5 36t44 46t67 36t91.5 16q45 0 91.5 -18t84.5 -36t63 -18q99 0 134 72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 1413,
    d: "M719 1389q206 0 350.5 -90t213.5 -244.5t69 -360.5q0 -151 -51 -285t-138.5 -229.5t-210 -151t-260.5 -55.5q-195 0 -339.5 93.5t-217 250t-72.5 353.5q0 151 50.5 284.5t137.5 228.5t208.5 150.5t259.5 55.5zM346 682q0 -222 101 -366t262 -144t260.5 144t99.5 366 t-99.5 366t-260.5 144t-262 -144t-101 -366zM344 1792h305l236 -279l-162 -57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 1413,
    d: "M719 1389q206 0 350.5 -90t213.5 -244.5t69 -360.5q0 -151 -51 -285t-138.5 -229.5t-210 -151t-260.5 -55.5q-195 0 -339.5 93.5t-217 250t-72.5 353.5q0 151 50.5 284.5t137.5 228.5t208.5 150.5t259.5 55.5zM346 682q0 -222 101 -366t262 -144t260.5 144t99.5 366 t-99.5 366t-260.5 144t-262 -144t-101 -366zM776 1772h305l-379 -336l-161 57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 1413,
    d: "M719 1389q206 0 350.5 -90t213.5 -244.5t69 -360.5q0 -151 -51 -285t-138.5 -229.5t-210 -151t-260.5 -55.5q-195 0 -339.5 93.5t-217 250t-72.5 353.5q0 151 50.5 284.5t137.5 228.5t208.5 150.5t259.5 55.5zM346 682q0 -222 101 -366t262 -144t260.5 144t99.5 366 t-99.5 366t-260.5 144t-262 -144t-101 -366zM600 1792h209l233 -272l-159 -62l-181 191l-176 -191l-159 62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 1413,
    d: "M719 1389q206 0 350.5 -90t213.5 -244.5t69 -360.5q0 -151 -51 -285t-138.5 -229.5t-210 -151t-260.5 -55.5q-195 0 -339.5 93.5t-217 250t-72.5 353.5q0 151 50.5 284.5t137.5 228.5t208.5 150.5t259.5 55.5zM346 682q0 -222 101 -366t262 -144t260.5 144t99.5 366 t-99.5 366t-260.5 144t-262 -144t-101 -366zM958 1702l111 -80q-2 -6 -5.5 -15.5t-21 -34.5t-40 -44.5t-65.5 -35t-95 -15.5q-54 0 -103.5 17.5t-86 34.5t-58.5 17q-41 0 -74.5 -17t-47.5 -35l-13 -17l-107 75q2 6 7 16t24.5 36t44 46t67 36t91.5 16q45 0 91.5 -18t84.5 -36 t63 -18q98 0 133 72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 1413,
    d: "M719 1389q206 0 350.5 -90t213.5 -244.5t69 -360.5q0 -151 -51 -285t-138.5 -229.5t-210 -151t-260.5 -55.5q-195 0 -339.5 93.5t-217 250t-72.5 353.5q0 151 50.5 284.5t137.5 228.5t208.5 150.5t259.5 55.5zM346 682q0 -222 101 -366t262 -144t260.5 144t99.5 366 t-99.5 366t-260.5 144t-262 -144t-101 -366zM631 1614q0 -52 -34.5 -88.5t-80.5 -36.5t-80.5 36.5t-34.5 88.5t34.5 89.5t80.5 37.5t80.5 -37.5t34.5 -89.5zM1008 1614q0 -52 -34.5 -88.5t-80.5 -36.5q-47 0 -81 36.5t-34 88.5t34 89.5t81 37.5q46 0 80.5 -37.5t34.5 -89.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 899,
    d: "M690 127l-241 240l-236 -236l-145 148l235 237l-254 250l184 104l209 -213l256 258l109 -192l-213 -211l240 -242z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 1413,
    d: "M719 1389q11 0 74 -5l38 166h156l-45 -194q200 -63 305 -237.5t105 -424.5q0 -151 -51 -285t-138.5 -229.5t-210 -151t-260.5 -55.5q-26 0 -76 4l-38 -163h-150l45 194q-195 66 -302.5 244.5t-107.5 417.5q0 151 50.5 284.5t137.5 228.5t208.5 150.5t259.5 55.5z M1069 682q0 150 -47.5 269t-132.5 182l-225 -957q28 -4 45 -4q161 0 260.5 144t99.5 366zM346 682q0 -150 47 -268t131 -181l224 955q-28 4 -39 4q-161 0 -262 -144t-101 -366z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 1466,
    d: "M1083 526v631l-28 211h264v-819q0 -259 -160.5 -417.5t-429.5 -158.5q-107 0 -194 28t-141.5 69t-95 98.5t-60 106.5t-30.5 102.5t-13 77.5t-2 41v661l-29 211h295v-856q0 -152 86.5 -245t220.5 -93q135 0 226 100t91 252zM385 1792h305l236 -279l-162 -57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 1466,
    d: "M1083 526v631l-28 211h264v-819q0 -259 -160.5 -417.5t-429.5 -158.5q-107 0 -194 28t-141.5 69t-95 98.5t-60 106.5t-30.5 102.5t-13 77.5t-2 41v661l-29 211h295v-856q0 -152 86.5 -245t220.5 -93q135 0 226 100t91 252zM817 1772h305l-379 -336l-161 57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 1466,
    d: "M1083 526v631l-28 211h264v-819q0 -259 -160.5 -417.5t-429.5 -158.5q-107 0 -194 28t-141.5 69t-95 98.5t-60 106.5t-30.5 102.5t-13 77.5t-2 41v661l-29 211h295v-856q0 -152 86.5 -245t220.5 -93q135 0 226 100t91 252zM641 1792h209l233 -272l-159 -62l-181 191 l-176 -191l-159 62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 1466,
    d: "M1083 526v631l-28 211h264v-819q0 -259 -160.5 -417.5t-429.5 -158.5q-107 0 -194 28t-141.5 69t-95 98.5t-60 106.5t-30.5 102.5t-13 77.5t-2 41v661l-29 211h295v-856q0 -152 86.5 -245t220.5 -93q135 0 226 100t91 252zM672 1614q0 -52 -34.5 -88.5t-80.5 -36.5 t-80.5 36.5t-34.5 88.5t34.5 89.5t80.5 37.5t80.5 -37.5t34.5 -89.5zM1049 1614q0 -52 -34.5 -88.5t-80.5 -36.5q-47 0 -81 36.5t-34 88.5t34 89.5t81 37.5q46 0 80.5 -37.5t34.5 -89.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 1126,
    d: "M707 612v-436l22 -176h-289v592l-313 602l-127 174h326l241 -467l27 -80l27 80l239 467h266zM662 1772h305l-379 -336l-162 57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 1138,
    d: "M170 1528l291 20v-305h133q95 0 180 -26.5t153.5 -77t109 -134t40.5 -188.5q0 -121 -71 -226t-199 -169t-283 -64h-59v-182l22 -176h-288v1317zM465 545h92q97 0 170.5 81.5t73.5 190.5q0 113 -71.5 179.5t-172.5 66.5h-92v-518z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 1212,
    d: "M539 49l26 211q15 -11 40.5 -27t86.5 -42.5t101 -26.5q65 0 102 25t37 90q0 38 -37 81t-90 84.5t-105.5 86.5t-89.5 102.5t-37 116.5q0 58 24.5 108t59.5 88t70 76.5t59.5 89.5t24.5 111q0 49 -38 90t-101 41q-107 0 -174.5 -60.5t-67.5 -160.5v-900l23 -233h-277v846 h-125v180h125v90q0 85 33 158t84.5 121.5t117 83t129.5 50t122 15.5q56 0 110 -9.5t106.5 -32.5t92 -57t64 -87.5t24.5 -120.5q0 -57 -23 -110.5t-56 -93.5t-66.5 -77t-56.5 -74.5t-23 -70.5q0 -42 26.5 -85.5t66.5 -78.5t86 -76.5t86 -80t66.5 -90t26.5 -105.5 q0 -131 -110 -226.5t-291 -95.5q-64 0 -127 19t-94 38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    horizAdvX: 1071,
    d: "M227 729l-104 180q6 6 18 16.5t53 37.5t87 47.5t119.5 37.5t150.5 17q53 0 101.5 -8.5t94.5 -30t79.5 -53t54 -80.5t20.5 -111v-530q0 -55 26.5 -116.5t52.5 -95.5l26 -34l-258 -29q-52 57 -70 127q-61 -61 -143 -96t-166 -35q-129 0 -214 81t-85 188q0 166 155 277 t422 120v39q0 205 -139 205q-45 0 -91 -16t-78.5 -38.5t-59 -45t-39.5 -38.5zM453 162q46 0 102.5 26.5t91.5 61.5v209q-315 -25 -315 -185q0 -46 31.5 -79t89.5 -33zM168 1483h305l236 -279l-162 -57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    horizAdvX: 1071,
    d: "M227 729l-104 180q6 6 18 16.5t53 37.5t87 47.5t119.5 37.5t150.5 17q53 0 101.5 -8.5t94.5 -30t79.5 -53t54 -80.5t20.5 -111v-530q0 -55 26.5 -116.5t52.5 -95.5l26 -34l-258 -29q-52 57 -70 127q-61 -61 -143 -96t-166 -35q-129 0 -214 81t-85 188q0 166 155 277 t422 120v39q0 205 -139 205q-45 0 -91 -16t-78.5 -38.5t-59 -45t-39.5 -38.5zM453 162q46 0 102.5 26.5t91.5 61.5v209q-315 -25 -315 -185q0 -46 31.5 -79t89.5 -33zM582 1462h305l-379 -336l-162 58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    horizAdvX: 1071,
    d: "M227 729l-104 180q6 6 18 16.5t53 37.5t87 47.5t119.5 37.5t150.5 17q53 0 101.5 -8.5t94.5 -30t79.5 -53t54 -80.5t20.5 -111v-530q0 -55 26.5 -116.5t52.5 -95.5l26 -34l-258 -29q-52 57 -70 127q-61 -61 -143 -96t-166 -35q-129 0 -214 81t-85 188q0 166 155 277 t422 120v39q0 205 -139 205q-45 0 -91 -16t-78.5 -38.5t-59 -45t-39.5 -38.5zM453 162q46 0 102.5 26.5t91.5 61.5v209q-315 -25 -315 -185q0 -46 31.5 -79t89.5 -33zM424 1483h209l233 -273l-159 -61l-181 190l-176 -190l-160 61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    horizAdvX: 1071,
    d: "M227 729l-104 180q6 6 18 16.5t53 37.5t87 47.5t119.5 37.5t150.5 17q53 0 101.5 -8.5t94.5 -30t79.5 -53t54 -80.5t20.5 -111v-530q0 -55 26.5 -116.5t52.5 -95.5l26 -34l-258 -29q-52 57 -70 127q-61 -61 -143 -96t-166 -35q-129 0 -214 81t-85 188q0 166 155 277 t422 120v39q0 205 -139 205q-45 0 -91 -16t-78.5 -38.5t-59 -45t-39.5 -38.5zM453 162q46 0 102.5 26.5t91.5 61.5v209q-315 -25 -315 -185q0 -46 31.5 -79t89.5 -33zM764 1393l110 -80q-2 -6 -5.5 -16t-21 -35t-40 -44t-65.5 -35t-95 -16q-54 0 -103.5 17.5t-86 35 t-58.5 17.5q-41 0 -74.5 -17.5t-46.5 -35.5l-14 -17l-106 76q2 6 7 16t24.5 36t43.5 46t66.5 36t91.5 16q45 0 92 -18t85 -36t63 -18q98 0 133 72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    horizAdvX: 1071,
    d: "M227 729l-104 180q6 6 18 16.5t53 37.5t87 47.5t119.5 37.5t150.5 17q53 0 101.5 -8.5t94.5 -30t79.5 -53t54 -80.5t20.5 -111v-530q0 -55 26.5 -116.5t52.5 -95.5l26 -34l-258 -29q-52 57 -70 127q-61 -61 -143 -96t-166 -35q-129 0 -214 81t-85 188q0 166 155 277 t422 120v39q0 205 -139 205q-45 0 -91 -16t-78.5 -38.5t-59 -45t-39.5 -38.5zM453 162q46 0 102.5 26.5t91.5 61.5v209q-315 -25 -315 -185q0 -46 31.5 -79t89.5 -33zM436 1305q0 -52 -34 -88.5t-80 -36.5t-80.5 36.5t-34.5 88.5t34.5 89.5t80.5 37.5t80 -37.5t34 -89.5z M813 1305q0 -52 -34.5 -88.5t-80.5 -36.5q-47 0 -80.5 36.5t-33.5 88.5q0 53 33.5 90t80.5 37q46 0 80.5 -37.5t34.5 -89.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    horizAdvX: 1071,
    d: "M227 729l-104 180q6 6 18 16.5t53 37.5t87 47.5t119.5 37.5t150.5 17q53 0 101.5 -8.5t94.5 -30t79.5 -53t54 -80.5t20.5 -111v-530q0 -55 26.5 -116.5t52.5 -95.5l26 -34l-258 -29q-52 57 -70 127q-61 -61 -143 -96t-166 -35q-129 0 -214 81t-85 188q0 166 155 277 t422 120v39q0 205 -139 205q-45 0 -91 -16t-78.5 -38.5t-59 -45t-39.5 -38.5zM453 162q46 0 102.5 26.5t91.5 61.5v209q-315 -25 -315 -185q0 -46 31.5 -79t89.5 -33zM696 1311q0 -73 -56 -127t-130 -54q-72 0 -127 54t-55 127t54.5 126.5t127.5 53.5q74 0 130 -53.5 t56 -126.5zM600 1313q0 35 -27 61.5t-61 26.5q-36 0 -62 -26t-26 -62t25.5 -66t62.5 -30q40 0 64 29.5t24 66.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 1568,
    d: "M233 729l-118 174q6 7 18 17.5t53.5 38.5t88 49.5t121 39t153.5 17.5q78 0 156 -31.5t120 -81.5q53 48 130.5 80.5t162.5 32.5q74 0 134 -22.5t99 -56.5t69 -84.5t45.5 -96.5t25 -104t12.5 -94.5t4 -78.5l-49 -49l-567 -6q8 -131 69 -208t177 -77q53 0 107.5 15t95 37 t74 44t50.5 37l17 15l37 -215q-6 -6 -18.5 -16t-54 -35.5t-87.5 -45t-120 -35.5t-151 -16q-213 0 -339 156q-9 9 -15 18q-204 -174 -346 -174q-155 0 -236 80t-81 195q0 156 154 262t427 115v53q0 103 -39 154t-106 51q-45 0 -90 -16t-76.5 -38.5t-56.5 -45t-37 -38.5z M451 162q46 0 121 33.5t110 68.5q-31 121 -31 195q-38 -3 -73 -8t-83 -18t-82.5 -31t-59.5 -49t-25 -70q0 -49 31.5 -85t91.5 -36zM1094 891q-54 0 -95 -36.5t-63.5 -89.5t-34.5 -122l342 6q-4 58 -16.5 108t-47 92t-85.5 42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 1001,
    d: "M956 928l-116 -185q-53 66 -120.5 96.5t-131.5 30.5q-84 0 -143 -50.5t-85 -128t-26 -173.5q0 -90 25.5 -164t83 -123t137.5 -49q50 0 103 17t92.5 41t72.5 48t50 41l17 17l37 -213q-6 -7 -18 -17.5t-53 -38t-86.5 -48.5t-117.5 -38.5t-147 -17.5q-110 0 -199 45 t-144 120t-84 168t-29 194q0 113 33.5 214.5t96 180t160.5 124.5t218 46q71 0 135.5 -14t106 -34.5t73 -40.5t45.5 -34zM432 -100l25 106h125q21 -26 65.5 -57.5t81 -54.5t65.5 -61t29 -81q0 -78 -40 -132.5t-100.5 -77.5t-135.5 -23q-124 0 -240 80l62 141q33 -33 83 -48.5 t91 -15.5q75 0 75 56q0 20 -24 42.5t-54 40t-62.5 41t-45.5 44.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 1021,
    d: "M561 1065q74 0 134 -22.5t99 -56.5t69 -84.5t45.5 -96.5t25 -104t12.5 -94.5t4 -78.5l-49 -49h-567q8 -131 74 -214t182 -83q50 0 103.5 15t95 36.5t75.5 43t52 36.5l18 15l37 -209q-7 -6 -19.5 -16t-55 -35t-89 -44t-119.5 -35t-147 -16q-111 0 -201 43.5t-147.5 117 t-88 166t-30.5 192.5q0 116 28.5 216.5t86 181.5t153 128t219.5 47zM537 891q-80 0 -127 -63.5t-66 -168.5h342q-3 41 -11 78.5t-24.5 73.5t-45.5 58t-68 22zM184 1483h305l236 -279l-162 -57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 1021,
    d: "M561 1065q74 0 134 -22.5t99 -56.5t69 -84.5t45.5 -96.5t25 -104t12.5 -94.5t4 -78.5l-49 -49h-567q8 -131 74 -214t182 -83q50 0 103.5 15t95 36.5t75.5 43t52 36.5l18 15l37 -209q-7 -6 -19.5 -16t-55 -35t-89 -44t-119.5 -35t-147 -16q-111 0 -201 43.5t-147.5 117 t-88 166t-30.5 192.5q0 116 28.5 216.5t86 181.5t153 128t219.5 47zM537 891q-80 0 -127 -63.5t-66 -168.5h342q-3 41 -11 78.5t-24.5 73.5t-45.5 58t-68 22zM616 1462h306l-379 -336l-162 58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 1021,
    d: "M561 1065q74 0 134 -22.5t99 -56.5t69 -84.5t45.5 -96.5t25 -104t12.5 -94.5t4 -78.5l-49 -49h-567q8 -131 74 -214t182 -83q50 0 103.5 15t95 36.5t75.5 43t52 36.5l18 15l37 -209q-7 -6 -19.5 -16t-55 -35t-89 -44t-119.5 -35t-147 -16q-111 0 -201 43.5t-147.5 117 t-88 166t-30.5 192.5q0 116 28.5 216.5t86 181.5t153 128t219.5 47zM537 891q-80 0 -127 -63.5t-66 -168.5h342q-3 41 -11 78.5t-24.5 73.5t-45.5 58t-68 22zM440 1483h209l234 -273l-160 -61l-180 190l-176 -190l-160 61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 1021,
    d: "M561 1065q74 0 134 -22.5t99 -56.5t69 -84.5t45.5 -96.5t25 -104t12.5 -94.5t4 -78.5l-49 -49h-567q8 -131 74 -214t182 -83q50 0 103.5 15t95 36.5t75.5 43t52 36.5l18 15l37 -209q-7 -6 -19.5 -16t-55 -35t-89 -44t-119.5 -35t-147 -16q-111 0 -201 43.5t-147.5 117 t-88 166t-30.5 192.5q0 116 28.5 216.5t86 181.5t153 128t219.5 47zM537 891q-80 0 -127 -63.5t-66 -168.5h342q-3 41 -11 78.5t-24.5 73.5t-45.5 58t-68 22zM471 1305q0 -52 -34.5 -88.5t-80.5 -36.5t-80 36.5t-34 88.5t34 89.5t80 37.5t80.5 -37.5t34.5 -89.5zM848 1305 q0 -52 -34.5 -88.5t-80.5 -36.5q-47 0 -81 36.5t-34 88.5t34 89.5t81 37.5q46 0 80.5 -37.5t34.5 -89.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 581,
    d: "M418 1065v-889l22 -176h-276v827l-29 207zM-70 1483h306l235 -279l-162 -57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 581,
    d: "M418 1065v-889l22 -176h-276v827l-29 207zM362 1462h306l-379 -336l-162 58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 581,
    d: "M418 1065v-889l22 -176h-276v827l-29 207zM186 1483h209l234 -273l-160 -61l-180 190l-176 -190l-160 61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 581,
    d: "M418 1065v-889l22 -176h-276v827l-29 207zM217 1305q0 -52 -34.5 -88.5t-80.5 -36.5t-80 36.5t-34 88.5t34 89.5t80 37.5t80.5 -37.5t34.5 -89.5zM594 1305q0 -52 -34.5 -88.5t-80.5 -36.5q-47 0 -80.5 36.5t-33.5 88.5q0 53 33.5 90t80.5 37q46 0 80.5 -37.5t34.5 -89.5 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 1142,
    d: "M696 1411l256 111v-154l-137 -59q127 -135 196.5 -320t69.5 -381q0 -105 -19 -198t-61.5 -174t-104.5 -139t-152 -91t-201 -33q-95 0 -172 28t-124.5 69.5t-83.5 99t-53 106.5t-27 103t-11.5 78t-1.5 41q0 152 65.5 280.5t176.5 202.5t241 74q44 0 92.5 -12.5t75.5 -25.5 l27 -13q-59 124 -148 213l-297 -130l-55 127l223 99q-82 44 -184 63l71 170q184 -26 338 -135zM340 516q0 -157 63.5 -258.5t171.5 -101.5q232 0 232 483q0 100 -14 162q-43 33 -107 54.5t-111 21.5q-108 0 -171.5 -101.5t-63.5 -259.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    horizAdvX: 1214,
    d: "M1077 0h-276v598q0 149 -24.5 201.5t-100.5 52.5q-44 0 -86.5 -12t-71.5 -29t-52.5 -34.5t-34.5 -29.5l-11 -12v-559l22 -176h-276v825l-29 207l283 31v-125q67 61 153 94t172 33q60 0 114.5 -16.5t98.5 -47.5t70.5 -82.5t26.5 -115.5v-631zM881 1393l110 -80 q-2 -6 -5.5 -16t-21 -35t-40 -44t-65.5 -35t-95 -16q-54 0 -103.5 17.5t-86 35t-58.5 17.5q-41 0 -74.5 -17.5t-47.5 -35.5l-13 -17l-107 76q2 6 7 16t24.5 36t44 46t67 36t91.5 16q45 0 92 -18t85 -36t63 -18q98 0 133 72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 1153,
    d: "M1083 541q0 -115 -37 -217.5t-104.5 -180.5t-170.5 -124t-228 -46q-90 0 -168 30.5t-133 82t-94.5 120t-58.5 144.5t-19 154q0 115 36.5 216.5t103.5 178.5t171 121.5t231 44.5q212 0 341.5 -132t129.5 -392zM340 520q0 -158 63.5 -261t171.5 -103t172 103t64 261 t-64 260.5t-172 102.5t-171.5 -102.5t-63.5 -260.5zM215 1483h305l236 -279l-162 -57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 1153,
    d: "M1083 541q0 -115 -37 -217.5t-104.5 -180.5t-170.5 -124t-228 -46q-90 0 -168 30.5t-133 82t-94.5 120t-58.5 144.5t-19 154q0 115 36.5 216.5t103.5 178.5t171 121.5t231 44.5q212 0 341.5 -132t129.5 -392zM340 520q0 -158 63.5 -261t171.5 -103t172 103t64 261 t-64 260.5t-172 102.5t-171.5 -102.5t-63.5 -260.5zM647 1462h305l-379 -336l-161 58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 1153,
    d: "M1083 541q0 -115 -37 -217.5t-104.5 -180.5t-170.5 -124t-228 -46q-90 0 -168 30.5t-133 82t-94.5 120t-58.5 144.5t-19 154q0 115 36.5 216.5t103.5 178.5t171 121.5t231 44.5q212 0 341.5 -132t129.5 -392zM340 520q0 -158 63.5 -261t171.5 -103t172 103t64 261 t-64 260.5t-172 102.5t-171.5 -102.5t-63.5 -260.5zM471 1483h209l233 -273l-159 -61l-181 190l-176 -190l-159 61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 1153,
    d: "M1083 541q0 -115 -37 -217.5t-104.5 -180.5t-170.5 -124t-228 -46q-90 0 -168 30.5t-133 82t-94.5 120t-58.5 144.5t-19 154q0 115 36.5 216.5t103.5 178.5t171 121.5t231 44.5q212 0 341.5 -132t129.5 -392zM340 520q0 -158 63.5 -261t171.5 -103t172 103t64 261 t-64 260.5t-172 102.5t-171.5 -102.5t-63.5 -260.5zM829 1393l111 -80q-2 -6 -5.5 -16t-21 -35t-40 -44t-65.5 -35t-95 -16q-54 0 -103.5 17.5t-86 35t-58.5 17.5q-41 0 -74.5 -17.5t-46.5 -35.5l-14 -17l-107 76q2 6 7 16t24.5 36t44 46t67 36t91.5 16q45 0 91.5 -18 t84.5 -36t63 -18q98 0 133 72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 1153,
    d: "M1083 541q0 -115 -37 -217.5t-104.5 -180.5t-170.5 -124t-228 -46q-90 0 -168 30.5t-133 82t-94.5 120t-58.5 144.5t-19 154q0 115 36.5 216.5t103.5 178.5t171 121.5t231 44.5q212 0 341.5 -132t129.5 -392zM340 520q0 -158 63.5 -261t171.5 -103t172 103t64 261 t-64 260.5t-172 102.5t-171.5 -102.5t-63.5 -260.5zM502 1305q0 -52 -34.5 -88.5t-80.5 -36.5t-80.5 36.5t-34.5 88.5t34.5 89.5t80.5 37.5t80.5 -37.5t34.5 -89.5zM879 1305q0 -52 -34.5 -88.5t-80.5 -36.5q-47 0 -81 36.5t-34 88.5t34 89.5t81 37.5q46 0 80.5 -37.5 t34.5 -89.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    horizAdvX: 989,
    d: "M342 842q0 60 42 101.5t101 41.5q56 0 97 -42t41 -101q0 -57 -41 -97t-97 -40q-59 0 -101 40t-42 97zM342 170q0 60 42 101.5t101 41.5q56 0 97 -42t41 -101q0 -57 -41 -97t-97 -40q-59 0 -101 40t-42 97zM137 608h721l-57 -202h-664v202z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 1153,
    d: "M846 1348l-74 -306q144 -43 227.5 -169t83.5 -332q0 -115 -37 -217.5t-104.5 -180.5t-170.5 -124t-228 -46q-4 0 -12.5 1t-12.5 1l-76 -317h-149l80 342q-61 21 -110 59t-80 79.5t-54 92.5t-33.5 92t-17 84.5t-7.5 62t-1 32.5q0 251 146.5 407t395.5 156h11l67 283h156z M811 520q0 194 -92 297l-158 -661h14q108 0 172 103t64 261zM340 520q0 -190 86 -293l154 656h-5q-108 0 -171.5 -102.5t-63.5 -260.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    horizAdvX: 1212,
    d: "M1149 10l-266 -37q-52 66 -66 140q-6 -6 -16 -15.5t-45 -33.5t-73.5 -42.5t-97.5 -33.5t-120 -15q-81 0 -149.5 27.5t-114 89t-45.5 146.5v589l-29 207l283 31v-623q0 -144 22.5 -200t95.5 -56q46 0 90.5 13t74.5 32t53 37.5t34 31.5l11 13v514l-29 207l282 31v-807 q0 -34 11 -72t26 -68t30.5 -54.5t26.5 -37.5zM240 1483h305l235 -279l-162 -57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    horizAdvX: 1212,
    d: "M1149 10l-266 -37q-52 66 -66 140q-6 -6 -16 -15.5t-45 -33.5t-73.5 -42.5t-97.5 -33.5t-120 -15q-81 0 -149.5 27.5t-114 89t-45.5 146.5v589l-29 207l283 31v-623q0 -144 22.5 -200t95.5 -56q46 0 90.5 13t74.5 32t53 37.5t34 31.5l11 13v514l-29 207l282 31v-807 q0 -34 11 -72t26 -68t30.5 -54.5t26.5 -37.5zM672 1462h305l-379 -336l-162 58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 1212,
    d: "M1149 10l-266 -37q-52 66 -66 140q-6 -6 -16 -15.5t-45 -33.5t-73.5 -42.5t-97.5 -33.5t-120 -15q-81 0 -149.5 27.5t-114 89t-45.5 146.5v589l-29 207l283 31v-623q0 -144 22.5 -200t95.5 -56q46 0 90.5 13t74.5 32t53 37.5t34 31.5l11 13v514l-29 207l282 31v-807 q0 -34 11 -72t26 -68t30.5 -54.5t26.5 -37.5zM496 1483h209l233 -273l-160 -61l-180 190l-176 -190l-160 61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    horizAdvX: 1212,
    d: "M1149 10l-266 -37q-52 66 -66 140q-6 -6 -16 -15.5t-45 -33.5t-73.5 -42.5t-97.5 -33.5t-120 -15q-81 0 -149.5 27.5t-114 89t-45.5 146.5v589l-29 207l283 31v-623q0 -144 22.5 -200t95.5 -56q46 0 90.5 13t74.5 32t53 37.5t34 31.5l11 13v514l-29 207l282 31v-807 q0 -34 11 -72t26 -68t30.5 -54.5t26.5 -37.5zM526 1305q0 -52 -34 -88.5t-80 -36.5t-80.5 36.5t-34.5 88.5t34.5 89.5t80.5 37.5t80 -37.5t34 -89.5zM903 1305q0 -52 -34.5 -88.5t-80.5 -36.5q-47 0 -80.5 36.5t-33.5 88.5q0 53 33.5 90t80.5 37q46 0 80.5 -37.5t34.5 -89.5 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 1050,
    d: "M1051 1063l-506 -1243q-65 -160 -170.5 -239t-235.5 -79q-75 0 -147 29l-35 246q84 -35 152 -35q92 0 158 59t118 205l-285 825l-100 191l283 37l213 -656l22 -137l35 137l229 621zM608 1462h305l-378 -336l-162 58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    horizAdvX: 1153,
    d: "M164 -492v1803l-29 207l283 30v-592q118 109 250 109q83 0 156.5 -34.5t130 -99t89.5 -165.5t33 -225q0 -152 -67.5 -281.5t-192.5 -208t-280 -78.5q-27 0 -119 9v-297l22 -177h-276zM602 874q-98 0 -184 -106v-602q71 -8 151 -8q97 0 166.5 105.5t69.5 258.5 q0 162 -58.5 257t-144.5 95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 1050,
    d: "M1051 1063l-506 -1243q-65 -160 -170.5 -239t-235.5 -79q-75 0 -147 29l-35 246q84 -35 152 -35q92 0 158 59t118 205l-285 825l-100 191l283 37l213 -656l22 -137l35 137l229 621zM463 1305q0 -52 -34.5 -88.5t-80.5 -36.5t-80.5 36.5t-34.5 88.5t34.5 89.5t80.5 37.5 t80.5 -37.5t34.5 -89.5zM840 1305q0 -52 -34.5 -88.5t-80.5 -36.5q-47 0 -81 36.5t-34 88.5t34 89.5t81 37.5q46 0 80.5 -37.5t34.5 -89.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 581,
    d: "M418 1065v-889l22 -176h-276v827l-29 207z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 1732,
    d: "M63 674q0 137 33.5 252.5t91.5 196t135.5 136.5t164.5 82.5t180 26.5h974v-203h-489v-362h432l-51 -203h-381v-397h516l-51 -203h-889q-200 0 -352 86t-233 238.5t-81 349.5zM344 662q0 -207 102.5 -345.5t258.5 -138.5h182v1020h-182q-101 0 -185 -76t-130 -198.5 t-46 -261.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 1751,
    d: "M1300 1065q74 0 134 -22.5t99.5 -56.5t69 -84.5t45 -96.5t25.5 -103.5t13 -94.5t4 -79l-50 -49h-567q8 -132 69 -211.5t177 -79.5q53 0 107.5 15t95 37t74 44t50.5 37l17 15l37 -215q-6 -6 -18 -16t-53.5 -35.5t-88 -45t-120 -35.5t-150.5 -16q-214 0 -340 156 q-150 -156 -387 -156q-95 0 -172 28t-124.5 70t-83.5 100t-53 107.5t-27 104t-11.5 78.5t-1.5 41q0 251 146.5 407t395.5 156q222 0 346 -139q129 139 342 139zM340 520q0 -158 63.5 -261t171.5 -103t174 103.5t66 260.5t-66 260t-174 103t-171.5 -102.5t-63.5 -260.5z M1276 891q-80 0 -127 -63.5t-66 -168.5h342q-3 41 -11 78.5t-24.5 73.5t-45.5 58t-68 22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 843,
    d: "M315 1483h209l234 -273l-160 -61l-180 190l-176 -190l-160 61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 1085,
    d: "M719 1331q0 -73 -56.5 -126.5t-130.5 -53.5q-73 0 -127.5 53.5t-54.5 126.5t54.5 126.5t127.5 53.5q74 0 130.5 -53.5t56.5 -126.5zM623 1333q0 35 -27 61.5t-61 26.5q-37 0 -63 -26.5t-26 -61.5q0 -36 26 -66t63 -30q40 0 64 29.5t24 66.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 798,
    d: "M668 1393l110 -80q-2 -6 -5.5 -16t-21 -35t-40 -44t-65.5 -35t-95 -16q-54 0 -103.5 17.5t-86 35t-58.5 17.5q-41 0 -74.5 -17.5t-46.5 -35.5l-14 -17l-107 76q2 6 7 16t24.5 36t44 46t67 36t91.5 16q45 0 92 -18t85 -36t63 -18q98 0 133 72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10023",
    unicode: "\u0401",
    d: "M199 0v1157l-29 211h784v-203h-489v-362h432l-51 -203h-381v-397h516l-51 -203h-731zM498 1614q0 -52 -34.5 -88.5t-80.5 -36.5t-80.5 36.5t-34.5 88.5t34.5 89.5t80.5 37.5t80.5 -37.5t34.5 -89.5zM874 1614q0 -52 -34 -88.5t-80 -36.5q-47 0 -81 36.5t-34 88.5t34 89.5 t81 37.5q46 0 80 -37.5t34 -89.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10051",
    unicode: "\u0402",
    horizAdvX: 1392,
    d: "M1044 348v84q0 128 -58.5 187t-174.5 59q-57 0 -128 -15.5t-113 -30.5l-42 -16v-405q9 -67 29 -211h-295v1151h-231v219h794v-219h-297v-320q170 56 351 56q198 0 315 -113.5t117 -341.5v-84q0 -229 -73 -329.5t-237 -100.5q-27 0 -57.5 7t-47.5 15l-17 7l-35 246 q59 -35 112 -35q31 0 47.5 10.5t28.5 53.5t12 126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10052",
    unicode: "\u0403",
    horizAdvX: 993,
    d: "M199 1157l-29 211h784v-203h-489v-989l22 -176h-288v1157zM586 1769h305l-379 -335l-162 57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10053",
    unicode: "\u0404",
    horizAdvX: 1267,
    d: "M920 803v-213h-568q24 -191 143 -299.5t277 -108.5q107 0 217 50t197 143l49 -211q-96 -88 -233 -139.5t-269 -51.5q-103 0 -199 27t-180.5 83t-147.5 135.5t-99.5 192t-36.5 244.5q0 163 44.5 298t129 233t214 152.5t292.5 54.5q279 0 469 -170l-109 -197 q-161 164 -358 164q-168 0 -274 -109.5t-120 -277.5h562z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10054",
    unicode: "\u0405",
    horizAdvX: 1003,
    d: "M90 113l21 229q7 -7 19.5 -18.5t53 -40.5t83 -51.5t105 -41t122.5 -18.5q83 0 137.5 50t54.5 120q0 47 -32 87.5t-83.5 73t-113.5 65.5t-124 72t-113.5 85.5t-83.5 114.5t-32 149q0 171 114.5 287.5t301.5 116.5q216 0 381 -103l-51 -205q-6 5 -16 12.5t-44 27t-71 34.5 t-93 27t-112 12q-61 0 -113.5 -44.5t-52.5 -111.5q0 -48 32.5 -88.5t84.5 -72.5t114.5 -64t125 -71.5t114.5 -86t84.5 -117t32.5 -155.5q0 -178 -117.5 -296t-310.5 -118q-74 0 -144.5 14.5t-118 35t-84 41t-53.5 34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0406",
    unicode: "\u0406",
    horizAdvX: 673,
    d: "M467 1368v-1192l22 -176h-288v1157l-29 211h295z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10056",
    unicode: "\u0407",
    horizAdvX: 673,
    d: "M467 1368v-1192l22 -176h-288v1157l-29 211h295zM264 1614q0 -52 -34 -88.5t-80 -36.5t-80.5 36.5t-34.5 88.5t34.5 89.5t80.5 37.5t80 -37.5t34 -89.5zM641 1614q0 -52 -34.5 -88.5t-80.5 -36.5q-47 0 -80.5 36.5t-33.5 88.5q0 53 33.5 90t80.5 37q46 0 80.5 -37.5 t34.5 -89.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10057",
    unicode: "\u0408",
    horizAdvX: 663,
    d: "M473 1368v-1270q0 -80 -16 -153t-51 -138t-85.5 -112.5t-125 -75t-164.5 -27.5q-55 0 -152 19l15 229q55 -30 137 -30q80 0 128 82t48 206v1059l-29 211h295z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10058",
    unicode: "\u0409",
    horizAdvX: 1871,
    d: "M913 0v1155h-327l-11 -213q-19 -379 -42 -529q-44 -280 -160 -377q-76 -63 -189 -63q-83 0 -139 23l-25 219q41 -20 93 -20q28 0 51 11.5t41 38.5t31.5 59t24 85.5t18 104.5t13.5 130t10 148.5t9 171.5l11 213l-29 211h889v-516h123q129 0 227.5 -32t158.5 -90 t89.5 -134.5t29.5 -169.5t-29.5 -169.5t-89.5 -134.5t-158.5 -90t-227.5 -32h-392zM1180 653v-454h127q113 0 173 60.5t60 172.5q0 221 -285 221h-75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10059",
    unicode: "\u040A",
    horizAdvX: 1861,
    d: "M903 0v616h-444v-440l22 -176h-288v1157l-29 211h295v-528h444v317l-29 211h297v-528h123q255 0 380.5 -113.5t125.5 -306.5t-125.5 -306.5t-380.5 -113.5h-391zM1169 641v-442h127q113 0 173.5 57.5t60.5 169.5q0 215 -285 215h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10060",
    unicode: "\u040B",
    horizAdvX: 1421,
    d: "M31 1151v219h794v-219h-297v-320q170 56 351 56q198 0 315 -113.5t117 -341.5v-221l28 -211h-295v432q0 128 -58.5 187t-174.5 59q-57 0 -128 -15.5t-113 -30.5l-42 -16v-405q9 -67 29 -211h-295v1151h-231z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10061",
    unicode: "\u040C",
    horizAdvX: 1253,
    d: "M467 797h74l186 344q72 135 152.5 193.5t183.5 58.5q62 0 121 -25l24 -217q-44 16 -96 16q-39 0 -72 -30.5t-75 -104.5l-189 -336l467 -696h-319l-379 584h-78v-408l22 -176h-288v1157l-29 211h295v-571zM739 1769h305l-378 -335l-162 57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10062",
    unicode: "\u040E",
    horizAdvX: 1288,
    d: "M1298 1368l-469 -1055q-76 -171 -180 -255.5t-258 -84.5q-75 0 -149 35l-37 217q49 -26 151 -26q139 0 203 125l-403 780l-176 264h335l344 -672l33 -110l29 110l293 672h284zM676 1597q26 0 53.5 20.5t48 49.5t37 57.5t25.5 49.5l8 20l174 -59q-2 -7 -5.5 -18.5t-18 -45 t-32 -64t-47 -67.5t-63 -63.5t-81 -45t-99.5 -18.5t-99.5 18t-81.5 46t-62.5 62.5t-47 69t-31.5 62.5t-18 46l-6 18l174 59q3 -8 9 -21.5t24.5 -47.5t37.5 -59.5t47 -47t54 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10145",
    unicode: "\u040F",
    horizAdvX: 1566,
    d: "M193 0v1192l-23 176h289v-1145h639v969l-23 176h289v-1157l29 -211h-484v-334h-260v334h-456z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10017",
    unicode: "\u0410",
    horizAdvX: 1212,
    d: "M-20 0l526 1352l174 43l418 -1141l114 -254h-297l-116 317h-453l-121 -317h-245zM559 924l-147 -396h327l-141 398l-18 80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10018",
    unicode: "\u0411",
    horizAdvX: 1169,
    d: "M465 653v-454h127q112 0 172.5 60.5t60.5 172.5q0 221 -284 221h-76zM199 0v1157l-29 211h823v-203h-528v-313h125q254 0 380 -116.5t126 -309.5t-126 -309.5t-380 -116.5h-391z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10019",
    unicode: "\u0412",
    horizAdvX: 1179,
    d: "M465 1178v-349q55 0 100 -1.5t66 -3.5t41.5 -4.5t25.5 -2.5q27 39 46.5 93t19.5 106q0 91 -50.5 128.5t-164.5 37.5q-22 0 -84 -4zM170 1368l367 10q222 0 348.5 -80t126.5 -241q0 -76 -49 -153t-113 -134q120 -55 183 -142.5t63 -197.5q0 -95 -30 -172t-90 -135.5 t-158 -90.5t-228 -32h-391v1157zM465 633v-434h127q112 0 172.5 59t60.5 164q0 98 -68 154.5t-216 56.5h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10020",
    unicode: "\u0413",
    horizAdvX: 993,
    d: "M199 1157l-29 211h784v-203h-489v-989l22 -176h-288v1157z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10021",
    unicode: "\u0414",
    horizAdvX: 1404,
    d: "M565 1020q0 -249 -27.5 -443.5t-97.5 -363.5h480v942h-355v-135zM10 -334l4 547h140q86 166 115.5 355.5t29.5 451.5l2 137l-29 211h914v-1155h153l4 -547h-262l-2 334h-805l-2 -334h-262z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10022",
    unicode: "\u0415",
    d: "M199 0v1157l-29 211h784v-203h-489v-362h432l-51 -203h-381v-397h516l-51 -203h-731z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10024",
    unicode: "\u0416",
    horizAdvX: 1777,
    d: "M756 797v360l-29 211h295v-571h63l162 344q118 252 340 252q62 0 121 -25l25 -217q-44 16 -97 16q-41 0 -75.5 -31t-71.5 -104l-168 -336l446 -696h-317l-360 584h-68v-408l22 -176h-288v584h-68l-360 -584h-318l447 696l-168 336q-37 73 -72 104t-76 31q-52 0 -96 -16 l25 217q59 25 120 25q222 0 340 -252l162 -344h64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10025",
    unicode: "\u0417",
    horizAdvX: 1034,
    d: "M467 180q110 0 166.5 58t56.5 137q0 223 -239 223h-189v203h197q76 0 143 -13q66 82 66 218q0 83 -53 134.5t-144 51.5q-65 0 -150.5 -41t-166.5 -121l-109 197q96 83 206.5 124.5t221.5 41.5q96 0 177 -23.5t143 -70t97.5 -121.5t35.5 -172q0 -170 -176 -299 q100 -52 158.5 -136.5t58.5 -195.5q0 -181 -125.5 -291.5t-374.5 -110.5q-216 0 -434 142l49 211q90 -68 192.5 -107t192.5 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10026",
    unicode: "\u0418",
    horizAdvX: 1579,
    d: "M467 391l53 117l606 860h246v-1192l23 -176h-289v977l-53 -117l-607 -860h-245v1157l-29 211h295v-977z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10027",
    unicode: "\u0419",
    horizAdvX: 1579,
    d: "M467 391l53 117l606 860h246v-1192l23 -176h-289v977l-53 -117l-607 -860h-245v1157l-29 211h295v-977zM786 1583q26 0 53.5 20.5t48 49.5t37 57.5t25.5 49.5l8 20l175 -60q-2 -7 -6 -18.5t-18.5 -44.5t-31.5 -63.5t-47 -67.5t-63.5 -63.5t-81 -45t-99.5 -18.5 t-99.5 17.5t-81.5 46t-62.5 63t-47 68.5t-31.5 62.5t-18 45.5l-6 18l174 60q3 -8 9 -21.5t24.5 -47.5t37.5 -59.5t47 -47t54 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10028",
    unicode: "\u041A",
    horizAdvX: 1253,
    d: "M467 797h74l186 344q72 135 152.5 193.5t183.5 58.5q62 0 121 -25l24 -217q-44 16 -96 16q-39 0 -72 -30.5t-75 -104.5l-189 -336l467 -696h-319l-379 584h-78v-408l22 -176h-288v1157l-29 211h295v-571z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10029",
    unicode: "\u041B",
    horizAdvX: 1429,
    d: "M586 1155l-11 -213q-19 -379 -42 -529q-44 -280 -160 -377q-76 -63 -189 -63q-83 0 -139 23l-25 219q41 -20 93 -20q28 0 51 11.5t41 38.5t31.5 59t24 85.5t18 104.5t13.5 130t10 148.5t9 171.5l11 213l-29 211h928v-1190q3 -27 12 -91t12 -87h-291v1155h-368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10030",
    unicode: "\u041C",
    horizAdvX: 1830,
    d: "M911 127l-428 588l-67 133v-672l22 -176h-258v1157l-28 211h210l572 -813l522 813h178v-1192l23 -176h-289v846l-59 -131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10031",
    unicode: "\u041D",
    horizAdvX: 1566,
    d: "M1370 1368v-1192l23 -176h-289v578h-639v-402l22 -176h-288v1157l-29 211h295v-567h639v356l-29 211h295z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10032",
    unicode: "\u041E",
    horizAdvX: 1413,
    d: "M719 1389q206 0 350.5 -90t213.5 -244.5t69 -360.5q0 -151 -51 -285t-138.5 -229.5t-210 -151t-260.5 -55.5q-195 0 -339.5 93.5t-217 250t-72.5 353.5q0 151 50.5 284.5t137.5 228.5t208.5 150.5t259.5 55.5zM346 682q0 -222 101 -366t262 -144t260.5 144t99.5 366 t-99.5 366t-260.5 144t-262 -144t-101 -366z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10033",
    unicode: "\u041F",
    horizAdvX: 1566,
    d: "M1370 1368v-1192l23 -176h-289v1145h-639v-969l22 -176h-288v1157l-29 211h1200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10034",
    unicode: "\u0420",
    horizAdvX: 1138,
    d: "M170 1368h424q95 0 180 -26.5t153.5 -77t109 -134t40.5 -188.5q0 -121 -71 -226t-199 -169t-283 -64h-59v-307l22 -176h-288v1157zM465 688h92q99 0 171.5 73.5t72.5 180.5q0 111 -70 169t-174 58h-92v-481z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10035",
    unicode: "\u0421",
    horizAdvX: 1267,
    d: "M1219 1223l-109 -197q-161 164 -358 164q-113 0 -207 -71t-146.5 -189t-52.5 -254q0 -116 35.5 -211t95 -156t135.5 -94t160 -33q107 0 217 50t197 143l49 -211q-96 -88 -233 -139.5t-269 -51.5q-103 0 -199 27t-180.5 83t-147.5 135.5t-99.5 192t-36.5 244.5 q0 159 52.5 297t143.5 234.5t216.5 151.5t267.5 55q279 0 469 -170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10036",
    unicode: "\u0422",
    horizAdvX: 1138,
    d: "M0 1161v207h1139v-207h-443v-985l23 -176h-289v1161h-430z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10037",
    unicode: "\u0423",
    horizAdvX: 1288,
    d: "M1298 1368l-469 -1055q-76 -171 -180 -255.5t-258 -84.5q-75 0 -149 35l-37 217q49 -26 151 -26q139 0 203 125l-403 780l-176 264h335l344 -672l33 -110l29 110l293 672h284z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10038",
    unicode: "\u0424",
    horizAdvX: 1486,
    d: "M1155 686q0 141 -76.5 235.5t-212.5 104.5v-682q136 10 212.5 105t76.5 237zM332 684q0 -141 76.5 -235.5t212.5 -104.5v682q-136 -10 -212.5 -105t-76.5 -237zM610 -20v174q-158 10 -285 79.5t-200.5 187.5t-73.5 263q0 143 73 261.5t198.5 189.5t279.5 82l-22 172h297 v-172q158 -10 285 -80t200.5 -188t73.5 -263q0 -217 -159 -366t-398 -166l20 -174h-289z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10039",
    unicode: "\u0425",
    horizAdvX: 1097,
    d: "M0 0l418 684l-281 506l-131 178h326l209 -385l30 -72l27 72l221 385h271l-398 -651l406 -717h-299l-224 416l-32 71l-29 -71l-231 -416h-283z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10040",
    unicode: "\u0426",
    horizAdvX: 1511,
    d: "M1446 213l4 -547h-262l-2 334h-1004v1157l-28 211h295v-1155h577v944l-29 211h295v-1155h154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10041",
    unicode: "\u0427",
    horizAdvX: 1372,
    d: "M563 457q-198 0 -315 113.5t-117 340.5v246l-29 211h295v-457q0 -128 58.5 -186.5t175.5 -58.5q57 0 127.5 15t112.5 31l42 15v430q-23 175 -28 211h295v-1157l28 -211h-295v512q-167 -55 -350 -55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10042",
    unicode: "\u0428",
    horizAdvX: 2007,
    d: "M1577 1157l-29 211h295v-1368h-1663v1157l-28 211h294v-1155h433v944l-29 211h295v-1155h432v944z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10043",
    unicode: "\u0429",
    horizAdvX: 2062,
    d: "M1737 0h-1557v1157l-28 211h294v-1155h433v944l-29 211h295v-1155h432v944l-29 211h295v-1155h154l4 -547h-262z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10044",
    unicode: "\u042A",
    horizAdvX: 1280,
    d: "M322 0v1163h-322v205h590v-516h123q254 0 380 -116.5t126 -309.5t-126 -309.5t-380 -116.5h-391zM588 653v-454h127q113 0 173 60.5t60 172.5q0 221 -284 221h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10045",
    unicode: "\u042B",
    horizAdvX: 1742,
    d: "M446 653v-454h127q113 0 173.5 60.5t60.5 172.5q0 221 -285 221h-76zM180 0v1157l-28 211h297v-516h122q254 0 380 -116.5t126 -309.5t-126 -309.5t-380 -116.5h-391zM1556 1368v-1192l23 -176h-289v1157l-69 211h335z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10046",
    unicode: "\u042C",
    horizAdvX: 1138,
    d: "M446 653v-454h127q113 0 173.5 60.5t60.5 172.5q0 221 -285 221h-76zM180 0v1157l-28 211h297v-516h122q254 0 380 -116.5t126 -309.5t-126 -309.5t-380 -116.5h-391z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10047",
    unicode: "\u042D",
    horizAdvX: 1267,
    d: "M348 590v213h561q-14 168 -119.5 277.5t-273.5 109.5q-197 0 -358 -164l-109 197q190 170 469 170q163 0 292.5 -54.5t214 -152.5t129 -233t44.5 -298q0 -132 -36.5 -244.5t-99.5 -192t-147.5 -135.5t-180.5 -83t-199 -27q-132 0 -269 51.5t-233 139.5l49 211 q87 -93 197 -143t217 -50q158 0 276.5 108.5t142.5 299.5h-567z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10048",
    unicode: "\u042E",
    horizAdvX: 1900,
    d: "M1237 1389q191 0 328.5 -89.5t205.5 -245t68 -360.5q0 -151 -50.5 -285.5t-135.5 -229.5t-200.5 -150.5t-242.5 -55.5q-167 0 -297.5 79.5t-205 215.5t-91.5 310h-170v-402l23 -176h-289v1157l-28 211h294v-567h177q40 256 213 422t401 166zM895 682q0 -221 92.5 -365.5 t239.5 -144.5q146 0 237.5 144t91.5 366t-91.5 366t-237.5 144q-147 0 -239.5 -144.5t-92.5 -365.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10049",
    unicode: "\u042F",
    horizAdvX: 1230,
    d: "M1051 1368v-1157l28 -211h-297v496h-123l-319 -496h-309l362 541q-121 51 -180 152t-59 239q0 202 125 319t380 117h392zM784 694v475h-127q-113 0 -173 -62t-60 -181q0 -232 285 -232h75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10065",
    unicode: "\u0430",
    horizAdvX: 1071,
    d: "M227 729l-104 180q6 6 18 16.5t53 37.5t87 47.5t119.5 37.5t150.5 17q53 0 101.5 -8.5t94.5 -30t79.5 -53t54 -80.5t20.5 -111v-530q0 -55 26.5 -116.5t52.5 -95.5l26 -34l-258 -29q-52 57 -70 127q-61 -61 -143 -96t-166 -35q-129 0 -214 81t-85 188q0 166 155 277 t422 120v39q0 205 -139 205q-45 0 -91 -16t-78.5 -38.5t-59 -45t-39.5 -38.5zM453 162q46 0 102.5 26.5t91.5 61.5v209q-315 -25 -315 -185q0 -46 31.5 -79t89.5 -33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10066",
    unicode: "\u0431",
    horizAdvX: 1128,
    d: "M569 754q-103 0 -168 -87.5t-65 -217.5q0 -121 64 -207t169 -86q95 0 158.5 85.5t63.5 213.5q0 123 -63 211t-159 88zM1044 1454l-34 -237q-145 -20 -240.5 -38t-179.5 -44.5t-133 -58.5t-87.5 -81t-57 -110t-29.5 -148q119 199 368 199q184 0 297 -128t113 -333 q0 -219 -144 -360.5t-385 -141.5q-200 0 -332 131t-132 340v68q0 129 8 229t29 184t50 144.5t77 110.5t104 83.5t138 60.5t171.5 45t210.5 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10067",
    unicode: "\u0432",
    horizAdvX: 1054,
    d: "M514 860l-113 -4v-223h236q59 51 59 119q0 54 -45.5 82.5t-136.5 25.5zM401 459v-279h154q95 0 140.5 37t45.5 100q0 142 -211 142h-129zM137 1030l387 10q203 6 305.5 -63.5t102.5 -194.5q0 -124 -144 -196q95 -37 150 -102.5t55 -157.5q0 -75 -23 -132.5t-74.5 -102 t-141.5 -68t-217 -23.5h-377v854z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10068",
    unicode: "\u0433",
    horizAdvX: 866,
    d: "M137 1034h688v-180h-411v-678l22 -176h-276v858z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10069",
    unicode: "\u0434",
    horizAdvX: 1202,
    d: "M406 154h364v700h-262v-76q0 -164 -26 -335t-76 -289zM909 -27h-647v-307h-248v488h121q104 189 117 624l2 49l-27 207h797v-880h133v-488h-248v307z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10070",
    unicode: "\u0435",
    horizAdvX: 1021,
    d: "M561 1065q74 0 134 -22.5t99 -56.5t69 -84.5t45.5 -96.5t25 -104t12.5 -94.5t4 -78.5l-49 -49h-567q8 -131 74 -214t182 -83q50 0 103.5 15t95 36.5t75.5 43t52 36.5l18 15l37 -209q-7 -6 -19.5 -16t-55 -35t-89 -44t-119.5 -35t-147 -16q-111 0 -201 43.5t-147.5 117 t-88 166t-30.5 192.5q0 116 28.5 216.5t86 181.5t153 128t219.5 47zM537 891q-80 0 -127 -63.5t-66 -168.5h342q-3 41 -11 78.5t-24.5 73.5t-45.5 58t-68 22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10072",
    unicode: "\u0436",
    horizAdvX: 1605,
    d: "M676 612v246l-23 176h277v-422h41l121 238q60 119 142.5 167t186.5 48q58 0 113 -25l27 -202q-53 22 -105 22q-85 0 -141 -110l-113 -218l393 -532h-313l-301 432h-51v-256l22 -176h-276v432h-51l-301 -432h-314l393 532l-112 218q-56 110 -141 110q-52 0 -105 -22 l27 202q55 25 112 25q104 0 187 -48t143 -167l121 -238h41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10073",
    unicode: "\u0437",
    horizAdvX: 948,
    d: "M459 881q-77 0 -152 -33.5t-135 -99.5l-117 180q5 6 16 15t48.5 32.5t80.5 41.5t113 33t146 15q181 0 288 -74.5t107 -206.5q0 -148 -135 -247q168 -82 168 -242q0 -152 -113 -237t-342 -85q-56 0 -116 13t-106.5 31.5t-85 36.5t-58.5 31l-21 13l37 209q8 -6 22.5 -15.5 t56.5 -34.5t82 -44.5t91 -35t92 -15.5q105 0 156 40t51 97q0 139 -178 139h-179v180h201q54 0 72 -2q65 58 65 140q0 53 -44 89t-111 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10074",
    unicode: "\u0438",
    horizAdvX: 1222,
    d: "M420 1063v-674l43 92l373 553h227v-858l22 -176h-276v645l-43 -92l-373 -553h-227v825l-29 207z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10075",
    unicode: "\u0439",
    horizAdvX: 1222,
    d: "M614 1298q27 0 51.5 18.5t40.5 45t28.5 52.5t17.5 44l6 19l184 -62q-3 -12 -9 -32t-32 -70.5t-59 -89.5t-94 -71t-134 -32q-53 0 -99.5 16.5t-79 42.5t-59 57.5t-42.5 62.5t-27 57t-15 42l-5 17l184 62q2 -7 5.5 -19t17 -43t28.5 -54.5t40 -43t52 -19.5zM420 1063v-674 l43 92l373 553h227v-858l22 -176h-276v645l-43 -92l-373 -553h-227v825l-29 207z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10076",
    unicode: "\u043A",
    horizAdvX: 1122,
    d: "M420 1063v-451h51l137 238q67 117 148.5 166t181.5 49q58 0 113 -25l26 -202q-53 22 -104 22q-75 0 -142 -110l-131 -218l412 -532h-317l-312 432h-63v-256l22 -176h-276v825l-29 207z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10077",
    unicode: "\u043B",
    horizAdvX: 1216,
    d: "M270 692l6 166l-22 176h803v-858l22 -176h-276v846h-273l-4 -146q-19 -727 -348 -727q-69 0 -133 25l-25 209q48 -23 91 -23q140 0 159 508z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10078",
    unicode: "\u043C",
    horizAdvX: 1492,
    d: "M457 485l-54 107v-416l23 -176h-266v858l-23 176h191l432 -565l391 565h182v-858l23 -176h-277v588l-63 -121l-260 -371z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10079",
    unicode: "\u043D",
    horizAdvX: 1222,
    d: "M420 1063v-457h389v219l-29 207l283 31v-887l22 -176h-276v426h-389v-250l22 -176h-276v825l-29 207z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10080",
    unicode: "\u043E",
    horizAdvX: 1153,
    d: "M1083 541q0 -115 -37 -217.5t-104.5 -180.5t-170.5 -124t-228 -46q-90 0 -168 30.5t-133 82t-94.5 120t-58.5 144.5t-19 154q0 115 36.5 216.5t103.5 178.5t171 121.5t231 44.5q212 0 341.5 -132t129.5 -392zM340 520q0 -158 63.5 -261t171.5 -103t172 103t64 261 t-64 260.5t-172 102.5t-171.5 -102.5t-63.5 -260.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10081",
    unicode: "\u043F",
    horizAdvX: 1216,
    d: "M137 1034h920v-858l22 -176h-276v854h-389v-678l22 -176h-276v858z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10082",
    unicode: "\u0440",
    horizAdvX: 1155,
    d: "M166 -492v1319l-29 207l283 31v-115q124 115 250 115q83 0 156.5 -34.5t130 -99t89.5 -165.5t33 -225q0 -152 -67.5 -281.5t-192.5 -208t-280 -78.5q-27 0 -119 9v-297l22 -177h-276zM604 854q-51 0 -97 -21.5t-67 -42.5l-20 -22v-602q71 -8 151 -8q97 0 166.5 105.5 t69.5 258.5q0 160 -57.5 246t-145.5 86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10083",
    unicode: "\u0441",
    horizAdvX: 1001,
    d: "M956 928l-116 -185q-53 66 -120.5 96.5t-131.5 30.5q-84 0 -143 -50.5t-85 -128t-26 -173.5q0 -90 25.5 -164t83 -123t137.5 -49q50 0 103 17t92.5 41t72.5 48t50 41l17 17l37 -213q-6 -7 -18 -17.5t-53 -38t-86.5 -48.5t-117.5 -38.5t-147 -17.5q-110 0 -199 45 t-144 120t-84 168t-29 194q0 113 33.5 214.5t96 180t160.5 124.5t218 46q71 0 135.5 -14t106 -34.5t73 -40.5t45.5 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10084",
    unicode: "\u0442",
    horizAdvX: 954,
    d: "M20 1034h914v-180h-330v-678l23 -176h-277v854h-330v180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10085",
    unicode: "\u0443",
    horizAdvX: 1056,
    d: "M1098 1063l-506 -1243q-65 -160 -170.5 -239t-235.5 -79q-75 0 -147 29l-35 246q84 -35 152 -35q92 0 158 59t118 205l-285 825l-100 191l283 37l213 -656l22 -137l35 137l229 621z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10086",
    unicode: "\u0444",
    horizAdvX: 1433,
    d: "M836 883v-752q131 12 199.5 115.5t68.5 259.5q0 169 -67.5 268t-200.5 109zM598 129v752q-131 -12 -199.5 -115.5t-68.5 -259.5q0 -169 67.5 -268t200.5 -109zM590 1051v268l-29 207l283 30v-503q253 -11 389.5 -145.5t136.5 -381.5q0 -108 -35 -205.5t-100.5 -175 t-166.5 -127t-224 -57.5v-276l22 -177h-276v451q-253 11 -390 145t-137 381q0 108 35.5 206t101 175.5t166.5 127t224 57.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10087",
    unicode: "\u0445",
    horizAdvX: 1052,
    d: "M0 0l383 516l-219 336l-150 174l295 37l193 -318l24 -55l29 55l197 281l301 37l-404 -526l355 -537h-291l-183 303l-28 53l-27 -55l-205 -301h-270z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10088",
    unicode: "\u0446",
    horizAdvX: 1216,
    d: "M1171 184v-491h-247v307h-758v825l-29 207l283 31v-879h364v641l-28 207l282 31v-879h133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10089",
    unicode: "\u0447",
    horizAdvX: 1148,
    d: "M989 1063v-887l23 -176h-277v340q-123 -37 -260 -37q-364 0 -364 383v139l-29 207l283 31v-377q0 -176 159 -176q38 0 91 10t87 20l33 9v276l-28 207z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10090",
    unicode: "\u0448",
    horizAdvX: 1671,
    d: "M1534 0h-1368v825l-29 207l283 31v-879h303v641l-29 207l283 31v-879h303v641l-29 207l283 31v-1063z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10091",
    unicode: "\u0449",
    horizAdvX: 1712,
    d: "M1667 184v-491h-248v307h-1253v825l-29 207l283 31v-879h303v641l-29 207l283 31v-879h303v641l-29 207l283 31v-879h133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10092",
    unicode: "\u044A",
    horizAdvX: 1142,
    d: "M543 1034v-346h102q124 0 214.5 -26t142.5 -73.5t76 -108t24 -136.5t-24 -136.5t-76 -108t-142.5 -73.5t-214.5 -26h-356v846h-289v188h543zM664 508h-125v-328h125q95 0 138.5 45t43.5 119t-43.5 119t-138.5 45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10093",
    unicode: "\u044B",
    horizAdvX: 1560,
    d: "M541 508h-125v-328h125q95 0 138.5 45t43.5 119t-43.5 119t-138.5 45zM420 1063v-375h102q124 0 214.5 -26t142.5 -73.5t76 -108t24 -136.5t-24 -136.5t-76 -108t-142.5 -73.5t-214.5 -26h-356v825l-29 207zM1401 1065v-889l22 -176h-276v827l-60 207z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10094",
    unicode: "\u044C",
    horizAdvX: 1019,
    d: "M541 508h-125v-328h125q95 0 138.5 45t43.5 119t-43.5 119t-138.5 45zM420 1063v-375h102q124 0 214.5 -26t142.5 -73.5t76 -108t24 -136.5t-24 -136.5t-76 -108t-142.5 -73.5t-214.5 -26h-356v825l-29 207z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10095",
    unicode: "\u044D",
    horizAdvX: 1001,
    d: "M281 424v192h381q-14 123 -76 188.5t-172 65.5q-64 0 -131.5 -30.5t-120.5 -96.5l-117 185q5 6 15 15t44.5 32.5t74.5 41.5t105 33t136 15q243 0 375.5 -152.5t132.5 -412.5q0 -101 -29 -194t-84.5 -168t-144.5 -120t-199 -45q-75 0 -146 16.5t-119 40t-85 47t-55 39.5 l-17 17l37 213q6 -7 18 -18t49 -39t74.5 -50t91 -39.5t103.5 -17.5q98 0 160.5 67.5t74.5 174.5h-376z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10096",
    unicode: "\u044E",
    horizAdvX: 1595,
    d: "M1532 541q0 -154 -62 -282t-184 -207t-282 -79q-98 0 -180.5 37.5t-139 101.5t-91.5 144.5t-46 169.5h-133v-250l22 -176h-276v858l-23 176h277v-428h135q26 215 163.5 337t360.5 122q198 0 328.5 -141t130.5 -383zM813 520q0 -157 61.5 -260.5t161.5 -103.5t162 104 t62 260t-62 259.5t-162 103.5q-101 0 -162 -103t-61 -260z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10097",
    unicode: "\u044F",
    horizAdvX: 1054,
    d: "M641 0v346h-86l-248 -346h-307l299 387q-197 79 -197 303q0 76 24 136.5t76 108t142.5 73.5t214.5 26h336v-858l23 -176h-277zM541 526h104v328h-104q-95 0 -139 -45t-44 -119t44 -119t139 -45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10071",
    unicode: "\u0451",
    horizAdvX: 1021,
    d: "M561 1065q74 0 134 -22.5t99 -56.5t69 -84.5t45.5 -96.5t25 -104t12.5 -94.5t4 -78.5l-49 -49h-567q8 -131 74 -214t182 -83q50 0 103.5 15t95 36.5t75.5 43t52 36.5l18 15l37 -209q-7 -6 -19.5 -16t-55 -35t-89 -44t-119.5 -35t-147 -16q-111 0 -201 43.5t-147.5 117 t-88 166t-30.5 192.5q0 116 28.5 216.5t86 181.5t153 128t219.5 47zM537 891q-80 0 -127 -63.5t-66 -168.5h342q-3 41 -11 78.5t-24.5 73.5t-45.5 58t-68 22zM471 1305q0 -52 -34.5 -88.5t-80.5 -36.5t-80 36.5t-34 88.5t34 89.5t80 37.5t80.5 -37.5t34.5 -89.5zM848 1305 q0 -52 -34.5 -88.5t-80.5 -36.5q-47 0 -81 36.5t-34 88.5t34 89.5t81 37.5q46 0 80.5 -37.5t34.5 -89.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10099",
    unicode: "\u0452",
    horizAdvX: 1208,
    d: "M1055 696v-348q0 -228 -71 -329t-226 -101q-27 0 -58 7t-48 15l-17 7l-35 246q60 -35 113 -35q31 0 47.5 10.5t28.5 53.5t12 126v144q0 148 -24.5 200.5t-100.5 52.5q-44 0 -86.5 -11.5t-71.5 -28t-52.5 -33t-34.5 -28.5l-11 -11v-457l22 -176h-276v1114h-121v176h121v29 l-29 207l283 30v-266h340v-176h-340v-278q66 60 151.5 91t173.5 31q60 0 114.5 -16.5t98.5 -47.5t70.5 -82.5t26.5 -115.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10100",
    unicode: "\u0453",
    horizAdvX: 866,
    d: "M137 1034h688v-180h-411v-678l22 -176h-276v858zM545 1421h305l-379 -336l-162 58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10101",
    unicode: "\u0454",
    horizAdvX: 1001,
    d: "M721 616v-192h-377q12 -107 75 -174.5t161 -67.5q50 0 103 17t92.5 41t72.5 48t50 41l17 17l37 -213q-6 -7 -18 -17.5t-53 -38t-86.5 -48.5t-117.5 -38.5t-147 -17.5q-110 0 -199 45t-144 120t-84 168t-29 194q0 260 132.5 412.5t375.5 152.5q71 0 135.5 -14t106 -34.5 t73 -40.5t45.5 -34l14 -14l-116 -185q-53 66 -120.5 96.5t-131.5 30.5q-110 0 -172 -65.5t-76 -188.5h381z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10102",
    unicode: "\u0455",
    horizAdvX: 874,
    d: "M70 94l24 215q7 -6 19 -15.5t49.5 -34t74 -43.5t87.5 -34.5t96 -15.5q61 0 105 26.5t44 75.5q0 32 -27.5 60t-71 50t-96.5 45t-106.5 51.5t-97 62.5t-71 84.5t-27.5 111.5q0 73 22.5 130.5t60.5 94.5t91 61t110 34t123 10q80 0 153 -17t106 -34l34 -17l-47 -204 q-4 4 -12 10t-36 22t-59 28t-80.5 22t-101.5 10q-53 0 -92 -28t-39 -69q0 -29 21.5 -54.5t56.5 -44t80 -39.5t92 -41t92 -49.5t80 -64t56.5 -85.5t21.5 -113q0 -154 -104.5 -238t-282.5 -84q-65 0 -125 12.5t-99 30.5t-68.5 35.5t-42.5 30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10103",
    unicode: "\u0456",
    horizAdvX: 581,
    d: "M416 1065v-889l22 -176h-276v827l-29 207zM141 1337q0 60 42.5 102t101.5 42q56 0 96.5 -42t40.5 -102q0 -57 -40.5 -97t-96.5 -40q-59 0 -101.5 40t-42.5 97z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10104",
    unicode: "\u0457",
    horizAdvX: 581,
    d: "M418 1065v-889l22 -176h-276v827l-29 207zM217 1305q0 -52 -34.5 -88.5t-80.5 -36.5t-80 36.5t-34 88.5t34 89.5t80 37.5t80.5 -37.5t34.5 -89.5zM594 1305q0 -52 -34.5 -88.5t-80.5 -36.5q-47 0 -80.5 36.5t-33.5 88.5q0 53 33.5 90t80.5 37q46 0 80.5 -37.5t34.5 -89.5 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10105",
    unicode: "\u0458",
    horizAdvX: 569,
    d: "M418 1065v-1030q0 -236 -116.5 -384.5t-295.5 -150.5l-88 211q134 0 190 91t56 255v770l-29 207zM141 1337q0 60 42.5 102t101.5 42q56 0 96.5 -42t40.5 -102q0 -57 -40.5 -97t-96.5 -40q-59 0 -101.5 40t-42.5 97z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10106",
    unicode: "\u0459",
    horizAdvX: 1603,
    d: "M270 692l6 166l-22 176h770v-346h82q124 0 214.5 -26t142.5 -73.5t76 -108t24 -136.5t-24 -136.5t-76 -108t-142.5 -73.5t-214.5 -26h-336v846h-240l-4 -146q-19 -727 -348 -727q-69 0 -133 25l-25 209q48 -23 91 -23q140 0 159 508zM1124 508h-104v-328h104q95 0 139 45 t44 119t-44 119t-139 45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10107",
    unicode: "\u045A",
    horizAdvX: 1622,
    d: "M420 1063v-416h368v178l-28 207l282 31v-416h82q124 0 214.5 -24.5t142.5 -69.5t76 -101.5t24 -127.5t-24 -128t-76 -102t-142.5 -69.5t-214.5 -24.5h-336v467h-368v-291l22 -176h-276v825l-29 207zM1143 467h-105v-287h105q95 0 138.5 40t43.5 104t-43.5 103.5 t-138.5 39.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10108",
    unicode: "\u045B",
    horizAdvX: 1208,
    d: "M760 1114h-340v-278q66 60 151.5 91t173.5 31q60 0 114.5 -16.5t98.5 -47.5t70.5 -82.5t26.5 -115.5v-524l22 -172h-276v492q0 148 -24.5 200.5t-100.5 52.5q-44 0 -86.5 -11.5t-71.5 -28t-52.5 -33t-34.5 -28.5l-11 -11v-457l22 -176h-276v1114h-121v176h121v29l-29 207 l283 30v-266h340v-176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10109",
    unicode: "\u045C",
    horizAdvX: 1122,
    d: "M420 1063v-451h51l137 238q67 117 148.5 166t181.5 49q58 0 113 -25l26 -202q-53 22 -104 22q-75 0 -142 -110l-131 -218l412 -532h-317l-312 432h-63v-256l22 -176h-276v825l-29 207zM668 1483h305l-379 -336l-162 57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10110",
    unicode: "\u045E",
    horizAdvX: 1056,
    d: "M1098 1063l-506 -1243q-65 -160 -170.5 -239t-235.5 -79q-75 0 -147 29l-35 246q84 -35 152 -35q92 0 158 59t118 205l-285 825l-100 191l283 37l213 -656l22 -137l35 137l229 621zM594 1305q27 0 51.5 18.5t40.5 44.5t28 52t18 44l5 19l185 -62q-3 -12 -9 -32t-32 -70.5 t-59 -89.5t-94 -71t-134 -32q-53 0 -100 16.5t-79 42.5t-59 57.5t-43 62.5t-27 57t-16 42l-4 17l185 62q2 -7 5.5 -19t17 -43t28.5 -54.5t40 -42.5t52 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10193",
    unicode: "\u045F",
    horizAdvX: 1216,
    d: "M485 0h-325v858l-23 176h277v-854h389v678l-23 176h277v-858l22 -176h-346v-307h-248v307z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10050",
    unicode: "\u0490",
    horizAdvX: 993,
    d: "M199 1157l-29 211h567v139h217v-342h-489v-989l22 -176h-288v1157z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10098",
    unicode: "\u0491",
    horizAdvX: 866,
    d: "M137 1034h463v158h225v-338h-411v-678l22 -176h-276v858z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 946,
    d: "M74 612h825l-57 -213h-768v213z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 1411,
    d: "M74 612h1286l-57 -213h-1229v213z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 573,
    d: "M387 1401l82 -101q-121 -108 -121 -198q0 -40 14 -59.5t46 -34.5v-15q0 -48 -40 -93.5t-98 -45.5q-61 0 -103 41t-42 117q0 83 65.5 190.5t196.5 198.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 573,
    d: "M186 854l-82 100q121 108 121 199q0 40 -13.5 59.5t-45.5 34.5v15q0 49 39.5 94t97.5 45q61 0 103.5 -41.5t42.5 -116.5q0 -83 -66 -190.5t-197 -198.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 573,
    d: "M186 -272l-82 100q121 108 121 199q0 40 -13.5 59.5t-45.5 34.5v14q0 49 39.5 94t97.5 45q61 0 103.5 -41t42.5 -116q0 -83 -66 -190.5t-197 -198.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 931,
    d: "M387 1401l82 -101q-121 -108 -121 -198q0 -40 14 -59.5t46 -34.5v-15q0 -48 -40 -93.5t-98 -45.5q-61 0 -103 41t-42 117q0 83 65.5 190.5t196.5 198.5zM745 1401l82 -101q-120 -107 -120 -198q0 -40 13.5 -59.5t45.5 -34.5v-15q0 -49 -39.5 -94t-97.5 -45 q-61 0 -103.5 41.5t-42.5 116.5q0 83 65.5 190.5t196.5 198.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 931,
    d: "M207 854l-82 100q121 108 121 199q0 40 -14 59.5t-46 34.5v15q0 48 40 93.5t98 45.5q61 0 103 -41t42 -117q0 -83 -65.5 -190.5t-196.5 -198.5zM565 854l-82 100q121 108 121 199q0 40 -13.5 59.5t-45.5 34.5v15q0 49 39.5 94t97.5 45q61 0 103 -41t42 -117 q0 -83 -65.5 -190.5t-196.5 -198.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 931,
    d: "M186 -272l-82 100q121 108 121 199q0 40 -13.5 59.5t-45.5 34.5v14q0 49 39.5 94t97.5 45q61 0 103.5 -41t42.5 -116q0 -83 -66 -190.5t-197 -198.5zM545 -272l-82 100q121 108 121 199q0 40 -14 59.5t-46 34.5v14q0 48 40 93.5t98 45.5q61 0 103 -41t42 -116 q0 -83 -65.5 -190.5t-196.5 -198.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 1017,
    d: "M592 -502h-252v1346h-264v190h264v293l252 31v-324h342l-80 -190h-262v-1346z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 1017,
    d: "M592 -502h-252v502h-264v190h264v654h-264v190h264v293l252 31v-324h342l-80 -190h-262v-654h315l-80 -190h-235v-502z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 888,
    d: "M442 817q129 0 221.5 -91t92.5 -220q0 -132 -92 -224t-222 -92q-132 0 -223.5 92t-91.5 224q0 129 91.5 220t223.5 91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 1509,
    d: "M403 104q0 -55 -37 -93t-90 -38q-56 0 -93.5 37.5t-37.5 93.5q0 53 38 90t93 37q52 0 89.5 -37.5t37.5 -89.5zM885 104q0 -55 -37 -93t-90 -38q-54 0 -92.5 38t-38.5 93q0 52 38.5 89.5t92.5 37.5q52 0 89.5 -37.5t37.5 -89.5zM1358 104q0 -55 -37.5 -93t-91.5 -38 t-91.5 38t-37.5 93q0 53 37.5 90t91.5 37t91.5 -37t37.5 -90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 2527,
    d: "M793 1038q0 -136 -102 -234.5t-238 -98.5q-133 0 -233.5 99t-100.5 234t100.5 234.5t233.5 99.5q136 0 238 -99t102 -235zM612 1040q0 62 -48 108t-109 46q-63 0 -109.5 -45.5t-46.5 -108.5q0 -61 45.5 -112t110.5 -51q71 0 114 50t43 113zM1448 1325l-918 -1325h-239 l962 1409zM1642 307q0 -136 -101.5 -235t-237.5 -99q-133 0 -233.5 99.5t-100.5 234.5t100.5 234.5t233.5 99.5q136 0 237.5 -99t101.5 -235zM1462 309q0 62 -48 108t-109 46q-63 0 -109.5 -45.5t-46.5 -108.5q0 -61 45.5 -112.5t110.5 -51.5q71 0 114 50.5t43 113.5z M2408 307q0 -136 -102 -235t-238 -99q-133 0 -233 99t-100 235t100 235t233 99q136 0 238 -99t102 -235zM2228 309q0 62 -48 108t-109 46q-63 0 -109.5 -45.5t-46.5 -108.5q0 -61 45.5 -112.5t110.5 -51.5q71 0 114 50.5t43 113.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 765,
    d: "M694 821l-313 -317l313 -314l-92 -184l-551 500l551 500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 765,
    d: "M72 190l313 318l-313 313l92 185l551 -500l-551 -500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 1114,
    d: "M1157 1309l-905 -1309h-260l956 1391z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    horizAdvX: 1251,
    d: "M8 922h139q63 220 239 343.5t407 123.5q99 0 206 -27.5t183 -77.5l-74 -205q-86 67 -164.5 87t-167.5 20q-126 0 -230 -70.5t-147 -193.5h652l-66 -183h-620q-8 -99 0 -149h583l-65 -182h-492q76 -226 379 -226q85 0 186 34.5t191 109.5v-234q-187 -119 -414 -119 q-104 0 -195 24.5t-170.5 75t-138 136t-86.5 199.5h-135v182h117q-3 32 -1.5 84.5t3.5 64.5h-119v183z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii61352",
    unicode: "\u2116",
    horizAdvX: 2150,
    d: "M1341 1368v-1192l15 -176h-170l-690 776l-80 129v-729l22 -176h-258v1157l-28 211h204l672 -790l78 -127v706l-29 211h264zM2099 1038q0 -136 -102 -234.5t-238 -98.5q-133 0 -233.5 99t-100.5 234t100.5 234.5t233.5 99.5q136 0 238 -99t102 -235zM1466 475v164h592 v-164h-592zM1919 1040q0 62 -48.5 108t-109.5 46q-63 0 -109 -45.5t-46 -108.5q0 -61 45 -112t110 -51q71 0 114.5 50t43.5 113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 1662,
    d: "M55 1284v160h592v-160h-190v-493l14 -117h-233v610h-183zM1167 698l-245 338v-245l14 -117h-221v637l-17 133h160l311 -438l279 438h158v-653l14 -117h-242v352z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "A",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xC6",
    k: 156
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xC5",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xC4",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xC3",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xC2",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xC1",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xC0",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "A",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xC6",
    k: 156
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xC5",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xC4",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xC3",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xC2",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xC1",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xC0",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "J",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0152",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xD8",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xD6",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xD5",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xD4",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xD3",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xD2",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xC7",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "Q",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "O",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "G",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "C",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0152",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xD8",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xD6",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xD5",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xD4",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xD3",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xD2",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xC7",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "Q",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "O",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "G",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "C",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "/",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u201D",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u201C",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u2019",
    k: 162
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u2018",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xFF",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xFD",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xDD",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "w",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "Y",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "W",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "T",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "'",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\"",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: ",",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: ".",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "o",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "e",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "a",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "A",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ",",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0153",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF6",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF5",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF4",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF3",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF2",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEB",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEA",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE9",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE8",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE7",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE6",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE5",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE4",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE3",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE2",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE1",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE0",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC5",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC4",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC3",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC2",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC1",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC0",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "c",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ".",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: ",",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: ".",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0152",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xD8",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xD6",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xD5",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xD4",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xD3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xD2",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\xC7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "Q",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "O",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "G",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "C",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "y",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "V",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u2019",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xFF",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xFD",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xDD",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "Y",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "W",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "T",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: ",",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u201E",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u201A",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "T",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: ".",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "o",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "e",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "a",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "A",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ",",
    k: 311
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0153",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF6",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF5",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF4",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF2",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xEB",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xEA",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE9",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE8",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE6",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE5",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE4",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE3",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE2",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE1",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE0",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC5",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC4",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC3",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC2",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC1",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC0",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "c",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ".",
    k: 311
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: ",",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u201E",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u201D",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u201C",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u201A",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u2019",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u2018",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "T",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: ".",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "'",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\"",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "o",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "e",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0153",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xF6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xF5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xF4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xF3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xF2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xEB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xEA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xE9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xE8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xE7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xDD",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "c",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "Y",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "W",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "T",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "y",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "o",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "e",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "a",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "A",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ":",
    k: 199
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ",",
    k: 240
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0153",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0152",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xFF",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xFD",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF6",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF5",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF4",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF3",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF2",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xEB",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xEA",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE9",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE8",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE7",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE6",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE5",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE4",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE3",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE2",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE1",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE0",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xD8",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xD6",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xD5",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xD4",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xD3",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xD2",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC7",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC6",
    k: 168
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC5",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC4",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC3",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC2",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC1",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC0",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "w",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "u",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "s",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "r",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "i",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "c",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "T",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "Q",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "O",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "G",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "C",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ";",
    k: 199
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ".",
    k: 240
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "-",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0153",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFF",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFD",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF6",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF5",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF4",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF3",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF2",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEB",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEA",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE9",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE8",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE7",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE6",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE5",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE4",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE3",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE2",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE1",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE0",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC6",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC5",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC4",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC3",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC2",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC1",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC0",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "u",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "r",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "i",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "c",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ";",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ".",
    k: 199
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "-",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "y",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "o",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "e",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "a",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "A",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ":",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ",",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0153",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xFF",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xFD",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF6",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF5",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF4",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF3",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF2",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xEB",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xEA",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE9",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE8",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE6",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE5",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE4",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE3",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE2",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE1",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE0",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC6",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC5",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC4",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC3",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC2",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC1",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC0",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "u",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "r",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "i",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "c",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ";",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ".",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "-",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "v",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "o",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "e",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "a",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "A",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ":",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ",",
    k: 195
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0153",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0152",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF6",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF5",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF4",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF3",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF2",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xEB",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xEA",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE9",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE8",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE7",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE6",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE5",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE4",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE3",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE2",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE1",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE0",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xD8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xD6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xD5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xD4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xD3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xD2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC6",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC5",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC4",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC3",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC2",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC1",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC0",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "z",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "w",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "u",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "t",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "s",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "q",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "p",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "n",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "m",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "i",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "c",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "Q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "O",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "G",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ";",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ".",
    k: 195
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "-",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "J",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: ",",
    k: 127
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "f",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: ".",
    k: 127
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "o",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "e",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: ",",
    k: 188
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\u0153",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xF6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xF5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xF4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xF3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xF2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xEB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xEA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xE9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xE8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xE7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "c",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: ".",
    k: 188
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "-",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ".",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: ",",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: ".",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: ".",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "J",
    k: -123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "y",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "v",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "V",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u201D",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u201C",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u2019",
    k: 162
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u2018",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xFF",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xFD",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xDD",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "w",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "Y",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "W",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "T",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "'",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\"",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "y",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "v",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "V",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u201D",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u201C",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u2019",
    k: 162
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u2018",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xFF",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xFD",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xDD",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "w",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "Y",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "W",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "T",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "'",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\"",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "y",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "v",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "V",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u201D",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u201C",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u2019",
    k: 162
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u2018",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xFF",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xFD",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xDD",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "w",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "Y",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "W",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "T",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "'",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\"",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "y",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "v",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "V",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u201D",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u201C",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u2019",
    k: 162
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u2018",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xFF",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xFD",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xDD",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "w",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "Y",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "W",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "T",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "'",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\"",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "y",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "v",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "V",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u201D",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u201C",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u2019",
    k: 162
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u2018",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xFF",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xFD",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xDD",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "w",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "Y",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "W",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "T",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "'",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\"",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "y",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "v",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "V",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u201D",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u201C",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u2019",
    k: 162
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u2018",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xFF",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xFD",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xDD",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "w",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "Y",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "W",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "T",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "'",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\"",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: ",",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u201E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u201A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "T",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: ".",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: ",",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u201E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u201D",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u201C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u201A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u2019",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u2018",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "T",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: ".",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "'",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\"",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: ",",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u201E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u201D",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u201C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u201A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u2019",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u2018",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "T",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: ".",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "'",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\"",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: ",",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u201A",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "T",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: ".",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: ",",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u201E",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u201D",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u201C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u201A",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u2019",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u2018",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "T",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: ".",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "'",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\"",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: ",",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u201E",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u201A",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "T",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: ".",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "v",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "o",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "e",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "a",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "A",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: ":",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: ",",
    k: 195
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u0153",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u0152",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF6",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF5",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF4",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF3",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF2",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xEB",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xEA",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE9",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE8",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE7",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE6",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE5",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE4",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE3",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE2",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE1",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE0",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xD8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xD6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xD5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xD4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xD3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xD2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC6",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC5",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC4",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC3",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC2",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC1",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC0",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "z",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "w",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "u",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "t",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "s",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "q",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "p",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "n",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "m",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "i",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "c",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "Q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "O",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "G",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: ";",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: ".",
    k: 195
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "-",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFD",
    u2: ",",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFD",
    u2: ".",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: ",",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: ".",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u042A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0423",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0427",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0425",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0424",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0422",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0416",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u040E",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u040B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0402",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "o",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "e",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "a",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "A",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: ",",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0153",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\xF6",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\xF5",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\xF4",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\xF3",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\xF2",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\xEB",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\xEA",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\xE9",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\xE8",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\xE7",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\xE6",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\xE5",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\xE4",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\xE3",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\xE2",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\xE1",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\xE0",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\xC5",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\xC4",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\xC3",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\xC2",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\xC1",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\xC0",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "c",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: ".",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0421",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: ",",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u044A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0447",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0442",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0427",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0424",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0404",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: ".",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u042A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0423",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0427",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0425",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0424",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0422",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0416",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u040E",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u040B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0402",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0152",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\xD8",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\xD6",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\xD5",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\xD4",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\xD3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\xD2",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\xC7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "Q",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "O",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "G",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "C",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u044C",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0443",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0441",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u043A",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0433",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0421",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "y",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "o",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "e",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "a",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "A",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: ":",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: ",",
    k: 199
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0491",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u045E",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u045C",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u045A",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0459",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0454",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0453",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0451",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u044F",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u044E",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u044D",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u044B",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0449",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0448",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0447",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0446",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0445",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0444",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0442",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0440",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u043F",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u043E",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u043D",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u043C",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u043B",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0439",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0438",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0437",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0436",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0435",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0434",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0432",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0431",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0430",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u042F",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0424",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u041E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u041B",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0414",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0410",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0404",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0153",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\xFF",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\xFD",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\xF6",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\xF5",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\xF4",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\xF3",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\xF2",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\xEB",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\xEA",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\xE9",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\xE8",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\xE7",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\xE6",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\xE5",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\xE4",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\xE3",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\xE2",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\xE1",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\xE0",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\xC6",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\xC5",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\xC4",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\xC3",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\xC2",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\xC1",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\xC0",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "u",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "r",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "i",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "c",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: ";",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: ".",
    k: 199
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "-",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0443",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u042A",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0423",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "y",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "v",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "V",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u201D",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u201C",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u2019",
    k: 162
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u2018",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u045E",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u044A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0447",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0442",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0427",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0422",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u040E",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u040B",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0402",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\xFF",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\xFD",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\xDD",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "w",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "Y",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "W",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "T",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "'",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\"",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u042A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0423",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u044A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0447",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0442",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0436",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0434",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u042F",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0427",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0422",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u040E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u040B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0402",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u042A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0423",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u044A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0447",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0442",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0436",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0434",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u042F",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0427",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u040E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u040B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0402",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u044C",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0443",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0441",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u043A",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0421",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "o",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "e",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "a",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "A",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: ",",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u045E",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u045C",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u045A",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0459",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0454",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0451",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u044F",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u044E",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u044D",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u044B",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u044A",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0449",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0447",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0446",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0445",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0444",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0440",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u043F",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u043E",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u043D",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u043C",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u043B",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0439",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0438",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0437",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0436",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0435",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0434",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0432",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0431",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0430",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u042F",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0424",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u041E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u041B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0414",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0410",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0404",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0153",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\xF6",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\xF5",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\xF4",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\xF3",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\xF2",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\xEB",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\xEA",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\xE9",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\xE8",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\xE7",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\xE6",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\xE5",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\xE4",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\xE3",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\xE2",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\xE1",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\xE0",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\xC5",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\xC4",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\xC3",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\xC2",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\xC1",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\xC0",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "c",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: ".",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0423",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0447",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0427",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0424",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u040E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0415",
    u2: "\u044A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0415",
    u2: "\u0447",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0415",
    u2: "\u0442",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0443",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0421",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u045E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u044A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0447",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0442",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0424",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u041E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0404",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0152",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\xD8",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\xD6",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\xD5",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\xD4",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\xD3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\xD2",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\xC7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "Q",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "O",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "G",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "C",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0423",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u042F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u040E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0443",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0421",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u045E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u044A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0447",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0442",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0424",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u041E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0404",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0152",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\xD8",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\xD6",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\xD5",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\xD4",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\xD3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\xD2",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\xC7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "Q",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "O",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "G",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "C",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u042A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u0423",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: ",",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u201E",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u201A",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u0424",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u0422",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u0416",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u040E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u040B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u0402",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "T",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: ".",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0441",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0423",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "o",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "e",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "a",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "A",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: ",",
    k: 311
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0454",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0451",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u044F",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0447",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0444",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u043E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u043B",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0435",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0434",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0430",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u042F",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u041B",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0416",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0414",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0410",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u040E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0153",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\xF6",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\xF5",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\xF4",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\xF3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\xF2",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\xEB",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\xEA",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\xE9",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\xE8",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\xE7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\xE6",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\xE5",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\xE4",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\xE3",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\xE2",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\xE1",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\xE0",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\xC5",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\xC4",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\xC3",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\xC2",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\xC1",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\xC0",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "c",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: ".",
    k: 311
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u044A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0447",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0442",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0427",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0424",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0404",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: ".",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044C",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0443",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0441",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043A",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u042A",
    k: -61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0421",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "y",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "o",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "e",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "a",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "A",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: ":",
    k: 199
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: ",",
    k: 240
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u045E",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u045C",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u045A",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0459",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0454",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0451",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044F",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044E",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044D",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044B",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044A",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0449",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0447",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0446",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0445",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0444",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0440",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043F",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043E",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043D",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043C",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043B",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0439",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0438",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0437",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0436",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0435",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0434",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0432",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0431",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0430",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u042F",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0424",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0422",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u041E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u041B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0414",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u040B",
    k: -61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0404",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0402",
    k: -61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0153",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0152",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\xFF",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\xFD",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\xF6",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\xF5",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\xF4",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\xF3",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\xF2",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\xEB",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\xEA",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\xE9",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\xE8",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\xE7",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\xE6",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\xE5",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\xE4",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\xE3",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\xE2",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\xE1",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\xE0",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\xD8",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\xD6",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\xD5",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\xD4",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\xD3",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\xD2",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\xC7",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\xC6",
    k: 168
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\xC5",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\xC4",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\xC3",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\xC2",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\xC1",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\xC0",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "w",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "u",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "s",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "r",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "i",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "c",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "Q",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "O",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "G",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "C",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: ";",
    k: 199
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: ".",
    k: 240
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "-",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0491",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u045E",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u045C",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u045A",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0459",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0454",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0453",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0451",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u044F",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u044E",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u044D",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u044B",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0449",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0448",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0447",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0446",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0445",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0444",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0442",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0440",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u043F",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u043E",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u043D",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u043C",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u043B",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0439",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0438",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0437",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0436",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0435",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0434",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0432",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0431",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0430",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u042F",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0424",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u041E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u041B",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0414",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0410",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0404",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0153",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\xFF",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\xFD",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\xF6",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\xF5",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\xF4",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\xF3",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\xF2",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\xEB",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\xEA",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\xE9",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\xE8",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\xE7",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\xE6",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\xE5",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\xE4",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\xE3",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\xE2",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\xE1",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\xE0",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\xC6",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\xC5",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\xC4",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\xC3",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\xC2",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\xC1",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\xC0",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "u",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "r",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "i",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "c",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: ";",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: ".",
    k: 199
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "-",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u042A",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0423",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0421",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: ",",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u042F",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u042D",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0424",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0422",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u041E",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0416",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0414",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u040E",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u040B",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0404",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0402",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: ".",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0447",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0423",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0447",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0427",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0424",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u040E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0423",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0447",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0427",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0424",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u040E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0427",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0425",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0424",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0422",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0416",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u040E",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u040B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0402",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u042A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0423",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0427",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0425",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0424",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0422",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0416",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u040E",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u040B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0402",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0423",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: ",",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u042D",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0424",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0422",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0416",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u040E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: ".",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0423",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0424",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0422",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0416",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u040E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: "o",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: "e",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: "a",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: "A",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: ",",
    k: 311
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: "\u0153",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: "\xF6",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: "\xF5",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: "\xF4",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: "\xF3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: "\xF2",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: "\xEB",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: "\xEA",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: "\xE9",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: "\xE8",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: "\xE7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: "\xE6",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: "\xE5",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: "\xE4",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: "\xE3",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: "\xE2",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: "\xE1",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: "\xE0",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: "\xC5",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: "\xC4",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: "\xC3",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: "\xC2",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: "\xC1",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: "\xC0",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: "c",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: ".",
    k: 311
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u0447",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u0442",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0443",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u045E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u044F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u044D",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u044A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0447",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0445",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0442",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u043B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0436",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0434",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0447",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0442",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0431",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: ",",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0444",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u043B",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0434",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: ".",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0447",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0442",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u0444",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u044F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0447",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0444",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0437",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u044A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0447",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0442",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u044A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0447",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0442",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u0447",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0441",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: ",",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0454",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0444",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u043E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u043B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0434",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: ".",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0454",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u044F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0444",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u043B",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0434",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: ".",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0443",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u045E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u044A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0447",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0442",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u043B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0437",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0436",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0447",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0442",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0447",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0442",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0443",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u045E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u044A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0447",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0445",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0442",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0436",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0443",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u045E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u044A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0447",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0445",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0442",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0436",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u044A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0442",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u044A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0442",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u0447",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0441",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: ",",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0454",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u044F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0444",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u043B",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0434",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: ".",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "o",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "e",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "a",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "A",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: ",",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0153",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\xF6",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\xF5",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\xF4",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\xF3",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\xF2",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\xEB",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\xEA",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\xE9",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\xE8",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\xE7",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\xE6",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\xE5",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\xE4",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\xE3",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\xE2",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\xE1",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\xE0",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\xC5",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\xC4",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\xC3",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\xC2",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\xC1",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\xC0",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "c",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: ".",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "A",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC6",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC5",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC4",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC3",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC2",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC1",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC0",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "A",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u2019",
    k: 158
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0152",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xD8",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xD6",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xD5",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xD4",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xD3",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xD2",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xC7",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xC6",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xC5",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xC4",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xC3",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xC2",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xC1",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xC0",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "t",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "s",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "Q",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "O",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "G",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "C",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0152",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xD8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xD6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xD5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xD4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xD3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xD2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xC7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "Q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "O",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "G",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "A",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC6",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC5",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC4",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC3",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC2",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC1",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC0",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "A",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u0152",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xD8",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xD6",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xD5",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xD4",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xD3",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xD2",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xC7",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xC6",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xC5",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xC4",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xC3",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xC2",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xC1",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xC0",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "Q",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "O",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "G",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "C",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0152",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xD8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xD6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xD5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xD4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xD3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xD2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xC7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "Q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "O",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "G",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "V,W",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "v,w",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "y,yacute,ydieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W",
    g2: "y,yacute,ydieresis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W",
    g2: "e,egrave,eacute,ecircumflex,edieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oe",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W",
    g2: "comma,period",
    k: 199
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W",
    g2: "colon,semicolon",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w",
    g2: "comma,period",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "comma,period",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10051,afii10060,afii10044",
    g2: "afii10062,afii10037",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10051,afii10060,afii10044",
    g2: "afii10051,afii10060,afii10044",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037",
    g2: "y,yacute,ydieresis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037",
    g2: "e,egrave,eacute,ecircumflex,edieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oe",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037",
    g2: "comma,period",
    k: 199
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037",
    g2: "colon,semicolon",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037",
    g2: "afii10053,afii10035",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037",
    g2: "afii10068,afii10100,afii10098",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037",
    g2: "afii10076,afii10109",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037",
    g2: "afii10083,afii10101",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037",
    g2: "afii10085,afii10110",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037",
    g2: "afii10094,afii10106,afii10107",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110",
    g2: "comma,period",
    k: 152
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110",
    g2: "afii10083,afii10101",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10053,afii10035",
    g2: "comma,period",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10053,afii10035",
    g2: "afii10053,afii10035",
    k: 41
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubsetFontinSansCrBold);
export default __webpack_public_path__ + "static/media/subset-FontinSansCR-Bold.794912bcc72718da80017a258090eb55.svg";
export { ForwardRef as ReactComponent };